import React, { useState, useEffect, useCallback } from 'react';
import { createClient } from '@supabase/supabase-js';
import './mobile.css';

// IIASD Brand Colors
const colors = {
  navyDark: '#1a2b4a',
  navy: '#243a5e',
  navyLight: '#2d4a6f',
  green: '#4a7c59',
  greenLight: '#5a9a6a',
  greenPale: '#e8f5e9',
  orange: '#d4a84b',
  orangeLight: '#f5e6c8',
  white: '#ffffff',
  grayLight: '#f8f9fa',
  grayMid: '#6c757d',
  grayDark: '#343a40',
  border: '#dee2e6',
  danger: '#dc3545',
};

// Supabase config
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

// Initialize Supabase client
const supabase = SUPABASE_URL && SUPABASE_KEY 
  ? createClient(SUPABASE_URL, SUPABASE_KEY)
  : null;

// South Dakota Legislators data (2026 session)
const legislators = {
  1: { members: [
    { name: "Michael Rohl", party: "R", email: "michael.rohl@sdlegislature.gov", chamber: "Senate" },
    { name: "Nick Fosness", party: "R", email: "nick.fosness@sdlegislature.gov", chamber: "House" },
    { name: "Logan Manhart", party: "R", email: "logan.manhart@sdlegislature.gov", chamber: "House" },
  ]},
  2: { members: [
    { name: "John Sjaarda", party: "R", email: "john.sjaarda@sdlegislature.gov", chamber: "House" },
    { name: "Steve Kolbeck", party: "R", email: "steve.kolbeck@sdlegislature.gov", chamber: "Senate" },
    { name: "David Kull", party: "R", email: "david.kull@sdlegislature.gov", chamber: "House" },
  ]},
  3: { members: [
    { name: "Al Novstrup", party: "R", email: "al.novstrup@sdlegislature.gov", chamber: "House" },
    { name: "Carl Perry", party: "R", email: "carl.perry@sdlegislature.gov", chamber: "Senate" },
    { name: "Brandei Schaefbauer", party: "R", email: "brandei.schaefbauer@sdlegislature.gov", chamber: "House" },
  ]},
  4: { members: [
    { name: "Stephanie Sauder", party: "R", email: "stephanie.sauder@sdlegislature.gov", chamber: "Senate" },
    { name: "Dylan Jordan", party: "R", email: "dylan.jordan@sdlegislature.gov", chamber: "House" },
    { name: "Kent Roe", party: "R", email: "kent.roe@sdlegislature.gov", chamber: "House" },
  ]},
  5: { members: [
    { name: "Glen Vilhauer", party: "R", email: "glen.vilhauer@sdlegislature.gov", chamber: "Senate" },
    { name: "Josephine Garcia", party: "R", email: "josephine.garcia@sdlegislature.gov", chamber: "House" },
    { name: "Matt Roby", party: "R", email: "matt.roby@sdlegislature.gov", chamber: "House" },
  ]},
  6: { members: [
    { name: "Ernie Otten", party: "R", email: "ernie.otten@sdlegislature.gov", chamber: "Senate" },
    { name: "Aaron Aylward", party: "R", email: "aaron.aylward@sdlegislature.gov", chamber: "House" },
    { name: "Tim Czmowski", party: "R", email: "tim.czmowski@sdlegislature.gov", chamber: "House" },
  ]},
  7: { members: [
    { name: "Tim Reed", party: "R", email: "tim.reed@sdlegislature.gov", chamber: "Senate" },
    { name: "Roger DeGroot", party: "R", email: "roger.degroot@sdlegislature.gov", chamber: "House" },
    { name: "Mellissa Heermann", party: "R", email: "mellissa.heermann@sdlegislature.gov", chamber: "House" },
  ]},
  8: { members: [
    { name: "Casey Crabtree", party: "R", email: "casey.crabtree@sdlegislature.gov", chamber: "Senate" },
    { name: "Tim Reisch", party: "R", email: "tim.reisch@sdlegislature.gov", chamber: "House" },
    { name: "Tim Walburg", party: "R", email: "tim.walburg@sdlegislature.gov", chamber: "House" },
  ]},
  9: { members: [
    { name: "Bethany Soye", party: "R", email: "bethany.soye@sdlegislature.gov", chamber: "House" },
    { name: "Joy Hohn", party: "R", email: "joy.hohn@sdlegislature.gov", chamber: "Senate" },
    { name: "Tesa Schwans", party: "R", email: "tesa.schwans@sdlegislature.gov", chamber: "House" },
  ]},
  10: { members: [
    { name: "Liz Larson", party: "D", email: "liz.larson@sdlegislature.gov", chamber: "Senate" },
    { name: "Bobbi Andera", party: "D", email: "bobbi.andera@sdlegislature.gov", chamber: "House" },
    { name: "Erin Healy", party: "D", email: "erin.healy@sdlegislature.gov", chamber: "House" },
  ]},
  11: { members: [
    { name: "Chris Karr", party: "R", email: "chris.karr@sdlegislature.gov", chamber: "Senate" },
    { name: "Brian Mulder", party: "R", email: "brian.mulder@sdlegislature.gov", chamber: "House" },
    { name: "Keri Weems", party: "R", email: "keri.weems@sdlegislature.gov", chamber: "House" },
  ]},
  12: { members: [
    { name: "Arch Beal", party: "R", email: "arch.beal@sdlegislature.gov", chamber: "Senate" },
    { name: "Amber Arlint", party: "R", email: "amber.arlint@sdlegislature.gov", chamber: "House" },
    { name: "Greg Jamison", party: "R", email: "greg.jamison@sdlegislature.gov", chamber: "House" },
  ]},
  13: { members: [
    { name: "Jack Kolbeck", party: "R", email: "jack.kolbeck@sdlegislature.gov", chamber: "House" },
    { name: "John Hughes", party: "R", email: "john.hughes@sdlegislature.gov", chamber: "House" },
    { name: "Sue Peterson", party: "R", email: "sue.peterson@sdlegislature.gov", chamber: "Senate" },
  ]},
  14: { members: [
    { name: "Larry Zikmund", party: "R", email: "larry.zikmund@sdlegislature.gov", chamber: "Senate" },
    { name: "Tony Kayser", party: "R", email: "tony.kayser@sdlegislature.gov", chamber: "House" },
    { name: "Taylor Rehfeldt", party: "R", email: "taylor.rehfeldt@sdlegislature.gov", chamber: "House" },
  ]},
  15: { members: [
    { name: "Kadyn Wittman", party: "D", email: "kadyn.wittman@sdlegislature.gov", chamber: "House" },
    { name: "Erik Muckey", party: "D", email: "erik.muckey@sdlegislature.gov", chamber: "House" },
    { name: "Jamie Smith", party: "D", email: "jamie.smith@sdlegislature.gov", chamber: "Senate" },
  ]},
  16: { members: [
    { name: "Kevin Jensen", party: "R", email: "kevin.jensen@sdlegislature.gov", chamber: "Senate" },
    { name: "Karla Lems", party: "R", email: "karla.lems@sdlegislature.gov", chamber: "House" },
    { name: "John Shubeck", party: "R", email: "john.shubeck@sdlegislature.gov", chamber: "House" },
  ]},
  17: { members: [
    { name: "Sydney Davis", party: "R", email: "sydney.davis@sdlegislature.gov", chamber: "Senate" },
    { name: "Chris Kassin", party: "R", email: "chris.kassin@sdlegislature.gov", chamber: "House" },
    { name: "William Shorma", party: "R", email: "william.shorma@sdlegislature.gov", chamber: "House" },
  ]},
  18: { members: [
    { name: "Lauren Nelson", party: "R", email: "lauren.nelson@sdlegislature.gov", chamber: "Senate" },
    { name: "Julie Auch", party: "R", email: "julie.auch@sdlegislature.gov", chamber: "House" },
    { name: "Mike Stevens", party: "R", email: "mike.stevens@sdlegislature.gov", chamber: "House" },
  ]},
  19: { members: [
    { name: "Kyle Schoenfish", party: "R", email: "kyle.schoenfish@sdlegislature.gov", chamber: "Senate" },
    { name: "Jessica Bahmuller", party: "R", email: "jessica.bahmuller@sdlegislature.gov", chamber: "House" },
    { name: "Drew Peterson", party: "R", email: "drew.peterson@sdlegislature.gov", chamber: "House" },
  ]},
  20: { members: [
    { name: "Paul Miskimins", party: "R", email: "paul.miskimins@sdlegislature.gov", chamber: "Senate" },
    { name: "Jeff Bathke", party: "R", email: "jeff.bathke@sdlegislature.gov", chamber: "House" },
    { name: "Kaley Nolz", party: "R", email: "kaley.nolz@sdlegislature.gov", chamber: "House" },
  ]},
  21: { members: [
    { name: "Marty Overweg", party: "R", email: "marty.overweg@sdlegislature.gov", chamber: "House" },
    { name: "Jim Halverson", party: "R", email: "jim.halverson@sdlegislature.gov", chamber: "House" },
    { name: "Mykala Voita", party: "R", email: "mykala.voita@sdlegislature.gov", chamber: "Senate" },
  ]},
  22: { members: [
    { name: "Lana Greenfield", party: "R", email: "lana.greenfield@sdlegislature.gov", chamber: "House" },
    { name: "Kevin Van Diepen", party: "R", email: "kevin.vandiepen@sdlegislature.gov", chamber: "House" },
    { name: "Brandon Wipf", party: "R", email: "brandon.wipf@sdlegislature.gov", chamber: "Senate" },
  ]},
  23: { members: [
    { name: "Mark Lapka", party: "R", email: "mark.lapka@sdlegislature.gov", chamber: "Senate" },
    { name: "Spencer Gosch", party: "R", email: "spencer.gosch@sdlegislature.gov", chamber: "House" },
    { name: "Scott Moore", party: "R", email: "scott.moore@sdlegislature.gov", chamber: "House" },
  ]},
  24: { members: [
    { name: "Jim Mehlhaff", party: "R", email: "jim.mehlhaff@sdlegislature.gov", chamber: "Senate" },
    { name: "Will Mortenson", party: "R", email: "will.mortenson@sdlegislature.gov", chamber: "House" },
    { name: "Mike Weisgram", party: "R", email: "mike.weisgram@sdlegislature.gov", chamber: "House" },
  ]},
  25: { members: [
    { name: "Tom Pischke", party: "R", email: "tom.pischke@sdlegislature.gov", chamber: "Senate" },
    { name: "Jon Hansen", party: "R", email: "jon.hansen@sdlegislature.gov", chamber: "House" },
    { name: "Leslie Heinemann", party: "R", email: "leslie.heinemann@sdlegislature.gov", chamber: "House" },
  ]},
  26: { members: [
    { name: "Tamara Grove", party: "R", email: "tamara.grove@sdlegislature.gov", chamber: "Senate" },
    { name: "Eric Emery", party: "D", email: "eric.emery@sdlegislature.gov", chamber: "House" },
    { name: "Rebecca Reimer", party: "R", email: "rebecca.reimer@sdlegislature.gov", chamber: "House" },
  ]},
  27: { members: [
    { name: "Red Dawn Foster", party: "D", email: "reddawn.foster@sdlegislature.gov", chamber: "Senate" },
    { name: "Liz May", party: "R", email: "liz.may@sdlegislature.gov", chamber: "House" },
    { name: "Peri Pourier", party: "D", email: "peri.pourier@sdlegislature.gov", chamber: "House" },
  ]},
  28: { members: [
    { name: "Sam Marty", party: "R", email: "sam.marty@sdlegislature.gov", chamber: "Senate" },
    { name: "Jana Hunt", party: "R", email: "jana.hunt@sdlegislature.gov", chamber: "House" },
    { name: "Travis Ismay", party: "R", email: "travis.ismay@sdlegislature.gov", chamber: "House" },
  ]},
  29: { members: [
    { name: "John Carley", party: "R", email: "john.carley@sdlegislature.gov", chamber: "Senate" },
    { name: "Terri Jorgenson", party: "R", email: "terri.jorgenson@sdlegislature.gov", chamber: "House" },
    { name: "Kathy Rice", party: "R", email: "kathy.rice@sdlegislature.gov", chamber: "House" },
  ]},
  30: { members: [
    { name: "Amber Hulse", party: "R", email: "amber.hulse@sdlegislature.gov", chamber: "Senate" },
    { name: "Tim Goodwin", party: "R", email: "tim.goodwin@sdlegislature.gov", chamber: "House" },
    { name: "Trish Ladner", party: "R", email: "trish.ladner@sdlegislature.gov", chamber: "House" },
  ]},
  31: { members: [
    { name: "Randy Deibert", party: "R", email: "randy.deibert@sdlegislature.gov", chamber: "Senate" },
    { name: "Mary Fitzgerald", party: "R", email: "mary.fitzgerald@sdlegislature.gov", chamber: "House" },
    { name: "Scott Odenbach", party: "R", email: "scott.odenbach@sdlegislature.gov", chamber: "House" },
  ]},
  32: { members: [
    { name: "Helene Duhamel", party: "R", email: "helene.duhamel@sdlegislature.gov", chamber: "Senate" },
    { name: "Steve Duffy", party: "R", email: "steve.duffy@sdlegislature.gov", chamber: "House" },
    { name: "Nicole Uhre-Balk", party: "D", email: "nicole.uhre-balk@sdlegislature.gov", chamber: "House" },
  ]},
  33: { members: [
    { name: "Curt Voight", party: "R", email: "curt.voight@sdlegislature.gov", chamber: "Senate" },
    { name: "Phil Jensen", party: "R", email: "phil.jensen@sdlegislature.gov", chamber: "House" },
    { name: "Curt Massie", party: "R", email: "curt.massie@sdlegislature.gov", chamber: "House" },
  ]},
  34: { members: [
    { name: "Taffy Howard", party: "R", email: "taffy.howard@sdlegislature.gov", chamber: "Senate" },
    { name: "Heather Baxter", party: "R", email: "heather.baxter@sdlegislature.gov", chamber: "House" },
    { name: "Mike Derby", party: "R", email: "mike.derby@sdlegislature.gov", chamber: "House" },
  ]},
  35: { members: [
    { name: "Tina Mulally", party: "R", email: "tina.mulally@sdlegislature.gov", chamber: "House" },
    { name: "Greg Blanc", party: "R", email: "greg.blanc@sdlegislature.gov", chamber: "Senate" },
    { name: "Tony Randolph", party: "R", email: "tony.randolph@sdlegislature.gov", chamber: "House" },
  ]},
};

// CSS-in-JS styles
const styles = {
  container: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    minHeight: '100vh',
    backgroundColor: colors.grayLight,
    color: colors.grayDark,
  },
  header: {
    backgroundColor: colors.navyDark,
    color: colors.white,
    padding: '0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  headerContent: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '1rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.75rem',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
  },
  logo: {
    fontSize: '1.25rem',
    fontWeight: '600',
    letterSpacing: '-0.02em',
  },
  logoAccent: {
    color: colors.orange,
    fontWeight: '700',
  },
  logoSubtext: {
    fontSize: '0.75rem',
    opacity: 0.8,
    fontWeight: '400',
    paddingLeft: '0.5rem',
    borderLeft: `1px solid ${colors.navyLight}`,
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  userEmail: {
    fontSize: '0.8rem',
    opacity: 0.9,
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  settingsBtn: {
    background: 'transparent',
    border: 'none',
    color: colors.white,
    padding: '0.5rem',
    cursor: 'pointer',
    opacity: 0.8,
    transition: 'opacity 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoutBtn: {
    background: 'transparent',
    border: `1px solid rgba(255,255,255,0.3)`,
    color: colors.white,
    padding: '0.5rem 1.25rem',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
  main: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '2rem',
  },
  pageHeader: {
    marginBottom: '2rem',
  },
  pageTitle: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: colors.navyDark,
    marginBottom: '0.5rem',
  },
  pageSubtitle: {
    color: colors.grayMid,
    fontSize: '1rem',
  },
  loginContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: colors.navyDark,
    backgroundImage: `linear-gradient(135deg, ${colors.navyDark} 0%, ${colors.navy} 100%)`,
  },
  loginBox: {
    backgroundColor: colors.white,
    padding: '3rem',
    borderRadius: '12px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    width: '100%',
    maxWidth: '420px',
  },
  loginLogo: {
    textAlign: 'center',
    marginBottom: '0.5rem',
    fontSize: '1.5rem',
    fontWeight: '700',
    color: colors.navyDark,
  },
  loginLogoAccent: {
    color: colors.green,
  },
  loginTitle: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: colors.grayMid,
    fontSize: '0.95rem',
    fontWeight: '400',
  },
  tabContainer: {
    display: 'flex',
    marginBottom: '1.5rem',
    borderBottom: `2px solid ${colors.border}`,
  },
  tab: {
    flex: 1,
    padding: '0.75rem',
    background: 'none',
    border: 'none',
    fontSize: '0.95rem',
    fontWeight: '500',
    color: colors.grayMid,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    position: 'relative',
  },
  tabActive: {
    color: colors.green,
  },
  tabIndicator: {
    position: 'absolute',
    bottom: '-2px',
    left: 0,
    right: 0,
    height: '2px',
    backgroundColor: colors.green,
  },
  input: {
    width: '100%',
    padding: '0.875rem 1rem',
    marginBottom: '1rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '1rem',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '0.875rem',
    backgroundColor: colors.green,
    color: colors.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  buttonDisabled: {
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  error: {
    color: colors.danger,
    marginBottom: '1rem',
    textAlign: 'center',
    padding: '0.75rem',
    backgroundColor: '#fdf2f2',
    borderRadius: '6px',
    fontSize: '0.9rem',
  },
  success: {
    color: colors.green,
    marginBottom: '1rem',
    textAlign: 'center',
    padding: '0.75rem',
    backgroundColor: colors.greenPale,
    borderRadius: '6px',
    fontSize: '0.9rem',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '1.25rem',
    marginBottom: '2rem',
  },
  statCard: {
    backgroundColor: colors.white,
    padding: '1.5rem',
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    borderLeft: `4px solid ${colors.navy}`,
  },
  statCardRelevant: {
    borderLeftColor: colors.green,
  },
  statCardNotRelevant: {
    borderLeftColor: colors.grayMid,
  },
  statNumber: {
    fontSize: '2.25rem',
    fontWeight: '700',
    color: colors.navyDark,
    lineHeight: 1.1,
  },
  statLabel: {
    color: colors.grayMid,
    fontSize: '0.875rem',
    marginTop: '0.25rem',
    fontWeight: '500',
  },
  filterBar: {
    display: 'flex',
    gap: '0.75rem',
    marginBottom: '1.5rem',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  filterLabel: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: colors.grayMid,
    marginRight: '0.5rem',
  },
  filterBtn: {
    padding: '0.5rem 1.25rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '20px',
    backgroundColor: colors.white,
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: colors.grayDark,
    transition: 'all 0.2s ease',
  },
  filterBtnActive: {
    padding: '0.5rem 1.25rem',
    border: `1px solid ${colors.green}`,
    borderRadius: '20px',
    backgroundColor: colors.green,
    color: colors.white,
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  searchInput: {
    padding: '0.5rem 1rem',
    paddingLeft: '2.5rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '0.875rem',
    minWidth: '220px',
    outline: 'none',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  },
  searchContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    position: 'absolute',
    left: '0.75rem',
    color: colors.grayMid,
    pointerEvents: 'none',
  },
  sortSelect: {
    padding: '0.5rem 2rem 0.5rem 1rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '0.875rem',
    backgroundColor: colors.white,
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236c757d' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 0.75rem center',
  },
  billCard: {
    backgroundColor: colors.white,
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '1rem',
    overflow: 'hidden',
    transition: 'box-shadow 0.2s ease',
    border: '1px solid #e0e0e0',
  },
  billHeader: {
    padding: '1.25rem 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    cursor: 'pointer',
    gap: '1rem',
  },
  billHeaderLeft: {
    flex: 1,
  },
  billNumber: {
    fontWeight: '700',
    fontSize: '1.125rem',
    color: colors.navyDark,
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  billTitle: {
    color: colors.grayMid,
    marginTop: '0.375rem',
    fontSize: '0.95rem',
    lineHeight: 1.5,
  },
  statusBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.75rem 1.5rem',
    backgroundColor: colors.grayLight,
    borderTop: `1px solid ${colors.border}`,
    fontSize: '0.85rem',
    flexWrap: 'wrap',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    color: colors.grayDark,
  },
  statusIcon: {
    width: '16px',
    height: '16px',
    color: colors.green,
  },
  hearingBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    backgroundColor: colors.orangeLight,
    color: '#8b6914',
    padding: '0.25rem 0.75rem',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '0.8rem',
  },
  expandIcon: {
    color: colors.grayMid,
    fontSize: '1.25rem',
    transition: 'transform 0.2s ease',
  },
  badge: {
    padding: '0.375rem 0.875rem',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    whiteSpace: 'nowrap',
  },
  badgeRelevant: {
    backgroundColor: colors.greenPale,
    color: colors.green,
  },
  badgeNotRelevant: {
    backgroundColor: '#f1f3f4',
    color: colors.grayMid,
  },
  badgeMaybe: {
    backgroundColor: colors.orangeLight,
    color: '#8b6914',
  },
  badgeConfidence: {
    fontSize: '0.65rem',
    marginLeft: '0.5rem',
    opacity: 0.7,
  },
  billDetails: {
    padding: '0 1.5rem 1.5rem 1.5rem',
    borderTop: `1px solid ${colors.border}`,
    backgroundColor: colors.grayLight,
  },
  section: {
    marginTop: '1.25rem',
  },
  sectionTitle: {
    fontWeight: '600',
    color: colors.navyDark,
    marginBottom: '0.5rem',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  sectionIcon: {
    width: '18px',
    height: '18px',
    color: colors.green,
  },
  sectionContent: {
    color: colors.grayDark,
    lineHeight: 1.7,
    fontSize: '0.95rem',
  },
  collapsibleHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '0.75rem 1rem',
    backgroundColor: colors.white,
    borderRadius: '6px',
    border: `1px solid ${colors.border}`,
    marginTop: '1.25rem',
    transition: 'background-color 0.2s ease',
  },
  collapsibleHeaderText: {
    fontWeight: '600',
    color: colors.navyDark,
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  collapsibleContent: {
    padding: '1rem',
    backgroundColor: colors.white,
    borderRadius: '0 0 6px 6px',
    border: `1px solid ${colors.border}`,
    borderTop: 'none',
  },
  collapsibleIcon: {
    fontSize: '0.75rem',
    color: colors.grayMid,
    transition: 'transform 0.2s ease',
  },
  subsection: {
    marginBottom: '1.25rem',
  },
  subsectionLast: {
    marginBottom: 0,
  },
  subsectionTitle: {
    fontWeight: '600',
    fontSize: '0.75rem',
    color: colors.grayMid,
    marginBottom: '0.5rem',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  linkButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: colors.white,
    backgroundColor: colors.navy,
    textDecoration: 'none',
    padding: '0.625rem 1.25rem',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'background-color 0.2s ease',
  },
  actionButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.75rem',
    alignItems: 'center',
    marginTop: '1rem',
  },
  followButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.625rem 1.25rem',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: 'none',
  },
  followButtonDefault: {
    backgroundColor: colors.white,
    color: colors.navy,
    border: `2px solid ${colors.navy}`,
  },
  followButtonFollowing: {
    backgroundColor: colors.green,
    color: colors.white,
    border: `2px solid ${colors.green}`,
  },
  followButtonLoading: {
    opacity: 0.7,
    cursor: 'wait',
  },
  similarBillsGrid: {
    display: 'grid',
    gap: '0.75rem',
  },
  similarBill: {
    padding: '1rem',
    backgroundColor: colors.grayLight,
    borderRadius: '8px',
    border: `1px solid ${colors.border}`,
  },
  similarBillHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '0.5rem',
  },
  similarBillState: {
    fontWeight: '700',
    color: colors.navyDark,
    fontSize: '0.95rem',
  },
  similarBillStatus: {
    fontSize: '0.7rem',
    padding: '0.25rem 0.5rem',
    backgroundColor: colors.white,
    borderRadius: '4px',
    color: colors.grayMid,
  },
  similarBillTitle: {
    fontSize: '0.875rem',
    color: colors.grayMid,
    lineHeight: 1.4,
  },
  keywordsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  keyword: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    padding: '0.25rem 0.75rem',
    borderRadius: '4px',
    fontSize: '0.8rem',
    color: colors.grayDark,
  },
  loading: {
    textAlign: 'center',
    padding: '4rem 2rem',
    color: colors.grayMid,
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: `3px solid ${colors.border}`,
    borderTopColor: colors.green,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 1rem',
  },
  emptyState: {
    textAlign: 'center',
    padding: '4rem 2rem',
    backgroundColor: colors.white,
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  },
  emptyStateIcon: {
    fontSize: '3rem',
    marginBottom: '1rem',
  },
  emptyStateTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: colors.navyDark,
    marginBottom: '0.5rem',
  },
  emptyStateText: {
    color: colors.grayMid,
  },
  lastUpdated: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '0.5rem',
    color: colors.grayMid,
    fontSize: '0.8rem',
    marginBottom: '1rem',
  },
  footer: {
    backgroundColor: colors.navyDark,
    color: 'rgba(255,255,255,0.7)',
    padding: '1.5rem 2rem',
    textAlign: 'center',
    fontSize: '0.85rem',
    marginTop: '3rem',
  },
  footerLink: {
    color: colors.orange,
    textDecoration: 'none',
  },
  // Pagination styles
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    padding: '1.5rem 0',
    marginTop: '1rem',
    borderTop: `1px solid ${colors.border}`,
  },
  paginationBtn: {
    padding: '0.6rem 1.2rem',
    backgroundColor: colors.navyDark,
    color: colors.white,
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'background-color 0.2s',
  },
  paginationBtnDisabled: {
    backgroundColor: colors.grayLight,
    color: colors.grayMedium,
    cursor: 'not-allowed',
  },
  paginationInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.25rem',
  },
  paginationText: {
    fontSize: '0.95rem',
    fontWeight: '500',
    color: colors.navyDark,
  },
  paginationSubtext: {
    fontSize: '0.8rem',
    color: colors.grayMedium,
  },
  // Toast styles
  toast: {
    position: 'fixed',
    bottom: '2rem',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: colors.navyDark,
    color: colors.white,
    padding: '0.85rem 1.25rem',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    zIndex: 1000,
    fontSize: '0.95rem',
  },
  toastAction: {
    backgroundColor: colors.orange,
    color: colors.white,
    border: 'none',
    padding: '0.4rem 0.8rem',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    whiteSpace: 'nowrap',
  },
  toastClose: {
    backgroundColor: 'transparent',
    color: 'rgba(255,255,255,0.7)',
    border: 'none',
    padding: '0.25rem',
    cursor: 'pointer',
    fontSize: '1.25rem',
    lineHeight: 1,
    marginLeft: '0.5rem',
  },
  // Notification banner styles
  notificationBanner: {
    backgroundColor: colors.white,
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    padding: '1.25rem 1.5rem',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    border: `1px solid ${colors.border}`,
    flexWrap: 'wrap',
  },
  notificationBannerConfigured: {
    backgroundColor: colors.greenPale,
    borderColor: colors.green,
  },
  notificationBannerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    flex: 1,
  },
  notificationIcon: {
    fontSize: '1.75rem',
  },
  notificationBannerText: {
    flex: 1,
  },
  notificationBannerTitle: {
    fontWeight: '600',
    color: colors.navyDark,
    fontSize: '1rem',
    marginBottom: '0.25rem',
  },
  notificationBannerSubtitle: {
    color: colors.grayMid,
    fontSize: '0.875rem',
  },
  notificationBannerBtn: {
    padding: '0.625rem 1.25rem',
    backgroundColor: colors.navy,
    color: colors.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    whiteSpace: 'nowrap',
  },
  notificationBannerBtnSecondary: {
    backgroundColor: 'transparent',
    color: colors.navy,
    border: `1px solid ${colors.navy}`,
  },
  // Modal styles
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '1rem',
  },
  modal: {
    backgroundColor: colors.white,
    borderRadius: '12px',
    padding: '2rem',
    maxWidth: '480px',
    width: '100%',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: '700',
    color: colors.navyDark,
    marginBottom: '0.5rem',
  },
  modalSubtitle: {
    color: colors.grayMid,
    marginBottom: '1.5rem',
    fontSize: '0.9rem',
    lineHeight: 1.5,
  },
  preferenceItem: {
    padding: '1rem',
    backgroundColor: colors.grayLight,
    borderRadius: '8px',
    marginBottom: '0.75rem',
    cursor: 'pointer',
    border: `2px solid transparent`,
    transition: 'all 0.2s ease',
  },
  preferenceItemActive: {
    backgroundColor: colors.greenPale,
    borderColor: colors.green,
  },
  preferenceHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  preferenceCheckbox: {
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    border: `2px solid ${colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: colors.white,
  },
  preferenceCheckboxActive: {
    backgroundColor: colors.green,
    borderColor: colors.green,
  },
  preferenceLabel: {
    fontWeight: '600',
    color: colors.navyDark,
    fontSize: '0.95rem',
  },
  preferenceDescription: {
    color: colors.grayMid,
    fontSize: '0.85rem',
    marginTop: '0.5rem',
    marginLeft: '2rem',
    lineHeight: 1.4,
  },
  modalActions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '1.5rem',
  },
  modalBtnPrimary: {
    flex: 1,
    padding: '0.875rem',
    backgroundColor: colors.green,
    color: colors.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
  },
  modalBtnSecondary: {
    padding: '0.875rem 1.25rem',
    backgroundColor: 'transparent',
    color: colors.grayMid,
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
  // Contact Legislator Modal styles
  contactModal: {
    backgroundColor: colors.white,
    borderRadius: '12px',
    padding: '2rem',
    maxWidth: '640px',
    width: '100%',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  contactSteps: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
    marginBottom: '1.5rem',
  },
  contactStep: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.375rem 0.75rem',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '500',
    color: colors.grayMid,
    backgroundColor: colors.grayLight,
  },
  contactStepActive: {
    backgroundColor: colors.green,
    color: colors.white,
  },
  contactStepComplete: {
    backgroundColor: colors.greenPale,
    color: colors.green,
  },
  contactInput: {
    width: '100%',
    padding: '0.75rem 1rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '0.95rem',
    marginBottom: '0.75rem',
    boxSizing: 'border-box',
  },
  contactInputRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: '0.75rem',
    marginBottom: '1rem',
  },
  contactLabel: {
    display: 'block',
    fontSize: '0.85rem',
    fontWeight: '600',
    color: colors.navyDark,
    marginBottom: '0.375rem',
  },
  stanceButton: {
    flex: 1,
    padding: '1rem',
    border: `2px solid ${colors.border}`,
    borderRadius: '8px',
    backgroundColor: colors.white,
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'all 0.2s ease',
  },
  stanceButtonActive: {
    borderColor: colors.green,
    backgroundColor: colors.greenPale,
  },
  templateCard: {
    padding: '1rem',
    border: `2px solid ${colors.border}`,
    borderRadius: '8px',
    marginBottom: '0.75rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  templateCardActive: {
    borderColor: colors.green,
    backgroundColor: colors.greenPale,
  },
  templateIcon: {
    fontSize: '1.25rem',
    marginRight: '0.5rem',
  },
  templateName: {
    fontWeight: '600',
    color: colors.navyDark,
  },
  messageTextarea: {
    width: '100%',
    minHeight: '180px',
    padding: '1rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '6px',
    fontSize: '0.9rem',
    lineHeight: 1.6,
    fontFamily: 'inherit',
    resize: 'vertical',
    boxSizing: 'border-box',
  },
  legislatorCheckList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginBottom: '1rem',
    padding: '1rem',
    backgroundColor: colors.grayLight,
    borderRadius: '8px',
  },
  legislatorChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    padding: '0.375rem 0.75rem',
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: '20px',
    fontSize: '0.85rem',
    cursor: 'pointer',
  },
  legislatorChipSelected: {
    backgroundColor: colors.green,
    borderColor: colors.green,
    color: colors.white,
  },
  sendAllButton: {
    width: '100%',
    padding: '1rem',
    backgroundColor: colors.orange,
    color: colors.navyDark,
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
  },
  contactButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.625rem 1rem',
    backgroundColor: colors.orange,
    color: colors.navyDark,
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
};

// Auth Component with Login/Signup tabs
function Auth({ onAuth }) {
  const [mode, setMode] = useState('login'); // 'login' or 'signup'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [agency, setAgency] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!supabase) {
      setError('Authentication service not configured');
      setLoading(false);
      return;
    }

    try {
      if (mode === 'signup') {
        // Sign up with Supabase Auth
        // emailRedirectTo is required, not optional. AK and SD share one
        // Supabase project, so there is a single Site URL for both apps -
        // without this, a confirmation link sends an SD signup to whichever
        // app that URL points at. See AK-Leg-Monitor/ENGINEERING_NOTES.md §3.
        const { data, error: signUpError } = await supabase.auth.signUp({
          email,
          password,
          options: {
            emailRedirectTo: window.location.origin,
            data: {
              name: name || null,
              agency: agency || null,
            }
          }
        });

        if (signUpError) throw signUpError;

        if (data.user) {
          // Create subscriber record linked to auth user.
          // upsert resolves with { error } rather than throwing, so an RLS
          // rejection here - likely, since no session exists yet at signup -
          // is silent unless it is destructured. See ENGINEERING_NOTES.md §4.
          const { error: subscriberError } = await supabase
            .from('subscribers')
            .upsert({
              id: data.user.id,
              email: data.user.email,
              name: name || null,
              agency: agency || null,
              verified: true,
            }, { onConflict: 'id' });

          if (subscriberError) {
            console.warn('Subscriber record not created:', subscriberError);
          }

          // Check if email confirmation is required
          if (data.session) {
            onAuth(data.user, data.session);
          } else {
            setSuccess('Account created! Check your email to confirm, then log in.');
            setMode('login');
          }
        }
      } else {
        // Login
        const { data, error: signInError } = await supabase.auth.signInWithPassword({
          email,
          password,
        });

        if (signInError) throw signInError;

        if (data.user && data.session) {
          onAuth(data.user, data.session);
        }
      }
    } catch (err) {
      console.error('Auth error:', err);
      if (err.message.includes('Invalid login credentials')) {
        setError('Invalid email or password');
      } else if (err.message.includes('User already registered')) {
        setError('An account with this email already exists. Try logging in.');
      } else if (err.message.includes('Password should be')) {
        setError('Password must be at least 6 characters');
      } else {
        setError(err.message || 'Something went wrong. Please try again.');
      }
    }

    setLoading(false);
  };

  return (
    <div style={styles.loginContainer}>
      <div className="login-box" style={styles.loginBox}>
        <div style={styles.loginLogo}>
          <span>IIASD</span>
          <span style={styles.loginLogoAccent}> Legislative Monitor</span>
        </div>
        <p style={styles.loginTitle}>
          {mode === 'login' 
            ? 'Sign in to access the legislative dashboard' 
            : 'Create an account to track bills'}
        </p>

        <div style={styles.tabContainer}>
          <button
            style={{
              ...styles.tab,
              ...(mode === 'login' ? styles.tabActive : {}),
            }}
            onClick={() => { setMode('login'); setError(''); setSuccess(''); }}
          >
            Sign In
            {mode === 'login' && <div style={styles.tabIndicator} />}
          </button>
          <button
            style={{
              ...styles.tab,
              ...(mode === 'signup' ? styles.tabActive : {}),
            }}
            onClick={() => { setMode('signup'); setError(''); setSuccess(''); }}
          >
            Sign Up
            {mode === 'signup' && <div style={styles.tabIndicator} />}
          </button>
        </div>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            style={styles.input}
          />
          
          {mode === 'signup' && (
            <>
              <input
                type="text"
                placeholder="Your Name (optional)"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={styles.input}
              />
              <input
                type="text"
                placeholder="Agency Name (optional)"
                value={agency}
                onChange={(e) => setAgency(e.target.value)}
                style={styles.input}
              />
            </>
          )}

          <button 
            type="submit" 
            style={{
              ...styles.button,
              ...(loading ? styles.buttonDisabled : {}),
            }}
            disabled={loading}
          >
            {loading 
              ? (mode === 'login' ? 'Signing in...' : 'Creating account...') 
              : (mode === 'login' ? 'Sign In' : 'Create Account')}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.8rem', color: colors.grayMid }}>
          Independent Insurance Agents of South Dakota
        </p>
      </div>
    </div>
  );
}

// Contact Legislator Modal
function ContactLegislatorModal({ isOpen, onClose, bill }) {
  const [step, setStep] = useState(1); // 1: address, 2: select legislators, 3: stance, 4: template, 5: send
  const [address, setAddress] = useState('');
  const [district, setDistrict] = useState(null);
  const [selectedLegislators, setSelectedLegislators] = useState([]);
  const [stance, setStance] = useState(null); // 'support' or 'oppose'
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [customMessage, setCustomMessage] = useState('');
  const [userFirstName, setUserFirstName] = useState('');
  const [userLastName, setUserLastName] = useState('');
  const [userCity, setUserCity] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const inputRef = React.useRef(null);

  // Reset state when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setAddress('');
      setDistrict(null);
      setSelectedLegislators([]);
      setStance(null);
      setSelectedTemplate(null);
      setCustomMessage('');
      setError('');
    }
  }, [isOpen]);

  // Initialize Google Places Autocomplete
  useEffect(() => {
    if (!isOpen || !inputRef.current || !window.google) return;
    
    const sdBounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(42.479635, -104.057698),
      new window.google.maps.LatLng(45.945716, -96.436589)
    );
    
    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      componentRestrictions: { country: 'us' },
      fields: ['formatted_address', 'geometry', 'address_components'],
      bounds: sdBounds,
      strictBounds: true
    });
    
    autocomplete.addListener('place_changed', async () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        setError('Please select an address from the dropdown');
        return;
      }
      
      const stateComponent = place.address_components?.find(
        c => c.types.includes('administrative_area_level_1')
      );
      
      if (stateComponent?.short_name !== 'SD') {
        setError('Please select an address in South Dakota');
        return;
      }
      
      // Extract city
      const cityComponent = place.address_components?.find(
        c => c.types.includes('locality')
      );
      if (cityComponent) {
        setUserCity(cityComponent.long_name);
      }
      
      setAddress(place.formatted_address);
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      await lookupDistrict(lat, lng);
    });
  }, [isOpen]);

  const lookupDistrict = async (lat, lng) => {
    setLoading(true);
    setError('');
    
    try {
      const url = `https://tigerweb.geo.census.gov/arcgis/rest/services/TIGERweb/Legislative/MapServer/identify?` +
        `geometry=${lng},${lat}&geometryType=esriGeometryPoint&sr=4326&` +
        `layers=all:1&tolerance=0&mapExtent=-104,43,-96,46&imageDisplay=800,600,96&` +
        `returnGeometry=false&f=json`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.results && data.results.length > 0) {
        const districtName = data.results[0].attributes.BASENAME || data.results[0].attributes.NAME;
        const districtNum = parseInt(districtName, 10);
        
        if (legislators[districtNum]) {
          setDistrict(districtNum);
          const members = legislators[districtNum].members.map((m, i) => ({
            ...m,
            id: `${districtNum}-${i}`,
            selected: true
          }));
          setSelectedLegislators(members);
          setStep(2);
        } else {
          setError(`District ${districtNum} not found. Please try a different address.`);
        }
      } else {
        setError('Could not determine your district. Please try a different address.');
      }
    } catch (err) {
      console.error('District lookup error:', err);
      setError('Error looking up district. Please try again.');
    }
    setLoading(false);
  };

  const handleStanceSelect = (selectedStance) => {
    setStance(selectedStance);
    setSelectedTemplate(null);
    setCustomMessage('');
    setStep(4);
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    // Build the message with placeholders
    const fullName = [userFirstName, userLastName].filter(Boolean).join(' ') || '[Your Name]';
    const message = template.body
      .replace(/\{\{NAME\}\}/g, fullName)
      .replace(/\{\{CITY\}\}/g, userCity || '[Your City]')
      .replace(/\{\{PHONE\}\}/g, userPhone || '');
    setCustomMessage(message);
    setStep(5);
  };

  const handleDraftOwn = () => {
    setSelectedTemplate(null);
    const stanceText = stance === 'support' ? 'support' : 'opposition to';
    setCustomMessage(`Dear {{TITLE}} {{LASTNAME}},

I am writing to express my ${stanceText} ${bill.bill_number}.

[Write your message here]

Thank you for your time and service to South Dakota.

Sincerely,
[Your Name]
[Your City], SD`);
    setStep(5);
  };

  const toggleLegislator = (id) => {
    setSelectedLegislators(prev => 
      prev.map(l => l.id === id ? { ...l, selected: !l.selected } : l)
    );
  };

  const getPersonalizedMessage = (legislator) => {
    const title = legislator.chamber === 'Senate' ? 'Senator' : 'Representative';
    const lastName = legislator.name.split(' ').pop();
    return customMessage
      .replace(/\{\{TITLE\}\}/g, title)
      .replace(/\{\{LASTNAME\}\}/g, lastName)
      .replace(/Dear (Senator|Representative) [^,]+,/g, `Dear ${title} ${lastName},`);
  };

  const openMailto = (legislator) => {
    const subject = encodeURIComponent(
      (stance === 'support' ? selectedTemplate?.subject : selectedTemplate?.subject)
        ?.replace('{bill_number}', bill.bill_number) || `Regarding ${bill.bill_number}`
    );
    const body = encodeURIComponent(getPersonalizedMessage(legislator));
    window.open(`mailto:${legislator.email}?subject=${subject}&body=${body}`, '_blank');
  };

  const copyMessage = () => {
    const selected = selectedLegislators.filter(l => l.selected);
    if (selected.length > 0) {
      navigator.clipboard.writeText(getPersonalizedMessage(selected[0]));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!isOpen) return null;

  const templates = bill.analysis?.email_templates?.[stance] || [];

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.contactModal} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={styles.modalTitle}>Contact Your Legislators</h2>
          <p style={{ color: colors.grayMid, fontSize: '0.9rem' }}>
            About: <strong>{bill.bill_number}</strong> - {bill.title?.substring(0, 60)}...
          </p>
        </div>

        {/* Steps indicator */}
        <div style={styles.contactSteps}>
          {['Address', 'Legislators', 'Position', 'Template', 'Send'].map((label, i) => (
            <div 
              key={label}
              style={{
                ...styles.contactStep,
                ...(step === i + 1 ? styles.contactStepActive : {}),
                ...(step > i + 1 ? styles.contactStepComplete : {}),
              }}
            >
              {step > i + 1 ? '✓' : i + 1}. {label}
            </div>
          ))}
        </div>

        {/* Step 1: Address */}
        {step === 1 && (
          <div>
            <label style={styles.contactLabel}>Enter your South Dakota address</label>
            <input
              ref={inputRef}
              type="text"
              placeholder="Start typing your address..."
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              style={styles.contactInput}
            />
            {error && <p style={{ color: colors.danger, fontSize: '0.85rem' }}>{error}</p>}
            {loading && <p style={{ color: colors.grayMid, fontSize: '0.85rem' }}>Looking up your district...</p>}
            
            <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: colors.grayLight, borderRadius: '8px', fontSize: '0.85rem' }}>
              <strong>🔒 Privacy:</strong> Your address is only used to find your legislators. We don't store or track your location.
            </div>
          </div>
        )}

        {/* Step 2: Select Legislators */}
        {step === 2 && (
          <div>
            <div style={{ 
              display: 'inline-block',
              backgroundColor: colors.navyDark, 
              color: 'white', 
              padding: '0.5rem 1rem', 
              borderRadius: '20px',
              fontSize: '0.9rem',
              fontWeight: '600',
              marginBottom: '0.75rem'
            }}>
              📍 District {district}
            </div>
            <p style={{ color: colors.grayMid, fontSize: '0.9rem', marginBottom: '0.5rem' }}>
              {address}
            </p>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: colors.navyDark, marginBottom: '0.5rem' }}>
              Select Legislators to Contact
            </h3>
            <p style={{ color: colors.grayMid, fontSize: '0.9rem', marginBottom: '1rem' }}>
              Choose one or more legislators to send your message to.
            </p>
            
            <div style={{ 
              backgroundColor: colors.orange + '20', 
              padding: '0.75rem 1rem', 
              borderRadius: '8px', 
              marginBottom: '1rem',
              fontSize: '0.9rem'
            }}>
              💡 Tip: Contacting all three maximizes your impact!
            </div>
            
            {selectedLegislators.map((leg) => {
              const initials = leg.name.split(' ').map(n => n[0]).join('');
              return (
                <div
                  key={leg.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '1rem',
                    backgroundColor: leg.selected ? colors.green + '15' : colors.grayLight,
                    border: leg.selected ? `2px solid ${colors.green}` : `2px solid ${colors.grayMid}40`,
                    borderRadius: '12px',
                    marginBottom: '0.75rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={() => toggleLegislator(leg.id)}
                >
                  {/* Checkbox */}
                  <div style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '6px',
                    backgroundColor: leg.selected ? colors.green : 'white',
                    border: leg.selected ? `2px solid ${colors.green}` : `2px solid ${colors.grayMid}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '1rem',
                    flexShrink: 0,
                  }}>
                    {leg.selected && <span style={{ color: 'white', fontWeight: 'bold' }}>✓</span>}
                  </div>
                  {/* Avatar */}
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: colors.navyDark,
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '1rem',
                    marginRight: '1rem',
                    flexShrink: 0,
                  }}>
                    {initials}
                  </div>
                  {/* Name & Title */}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', color: colors.navyDark }}>{leg.name}</div>
                    <div style={{ fontSize: '0.85rem', color: colors.grayMid }}>
                      State {leg.chamber === 'Senate' ? 'Senator' : 'Representative'}
                    </div>
                  </div>
                  {/* Party badge */}
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: colors.grayLight,
                    color: colors.grayMid,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '0.8rem',
                    border: `2px solid ${colors.grayMid}40`,
                    flexShrink: 0,
                  }}>
                    {leg.party}
                  </div>
                </div>
              );
            })}
            
            <p style={{ fontSize: '0.85rem', color: colors.grayMid, textAlign: 'center', marginTop: '0.5rem' }}>
              Click to select or deselect legislators
            </p>
            
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
              <button
                style={{ ...styles.modalBtnSecondary, flex: 1 }}
                onClick={() => setStep(1)}
              >
                ← Back
              </button>
              <button
                style={{ 
                  ...styles.modalBtnPrimary, 
                  flex: 1,
                  opacity: selectedLegislators.filter(l => l.selected).length === 0 ? 0.5 : 1,
                }}
                onClick={() => setStep(3)}
                disabled={selectedLegislators.filter(l => l.selected).length === 0}
              >
                Continue →
              </button>
            </div>
          </div>
        )}

        {/* Step 3: Stance */}
        {step === 3 && (
          <div>
            <p style={{ marginBottom: '1rem', color: colors.grayMid }}>
              Select your position on this bill:
            </p>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button
                style={{
                  ...styles.stanceButton,
                  ...(stance === 'support' ? styles.stanceButtonActive : {}),
                }}
                onClick={() => handleStanceSelect('support')}
              >
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>👍</div>
                <div style={{ fontWeight: '600', color: colors.navyDark }}>Support</div>
                <div style={{ fontSize: '0.85rem', color: colors.grayMid }}>I want this bill to pass</div>
              </button>
              <button
                style={{
                  ...styles.stanceButton,
                  ...(stance === 'oppose' ? styles.stanceButtonActive : {}),
                }}
                onClick={() => handleStanceSelect('oppose')}
              >
                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>👎</div>
                <div style={{ fontWeight: '600', color: colors.navyDark }}>Oppose</div>
                <div style={{ fontSize: '0.85rem', color: colors.grayMid }}>I want this bill defeated</div>
              </button>
            </div>
            <button
              style={{ ...styles.modalBtnSecondary, marginTop: '1.5rem' }}
              onClick={() => setStep(2)}
            >
              ← Back
            </button>
          </div>
        )}

        {/* Step 4: Template */}
        {step === 4 && (
          <div>
            <p style={{ marginBottom: '1rem', color: colors.grayMid }}>
              How would you like to write your message?
            </p>
            {/* Draft your own option */}
            <div
              style={styles.templateCard}
              onClick={handleDraftOwn}
            >
              <span style={styles.templateIcon}>✍️</span>
              <span style={styles.templateName}>Draft your own letter</span>
            </div>
            {/* Template options */}
            {templates.length > 0 && (
              <p style={{ marginTop: '1rem', marginBottom: '0.5rem', color: colors.grayMid, fontSize: '0.9rem' }}>
                Or choose a template ({stance === 'support' ? 'supporting' : 'opposing'} the bill):
              </p>
            )}
            {templates.map((template) => (
              <div
                key={template.id}
                style={{
                  ...styles.templateCard,
                  ...(selectedTemplate?.id === template.id ? styles.templateCardActive : {}),
                }}
                onClick={() => handleTemplateSelect(template)}
              >
                <span style={styles.templateIcon}>{template.icon}</span>
                <span style={styles.templateName}>{template.name}</span>
              </div>
            ))}
            <button
              style={{ ...styles.modalBtnSecondary, marginTop: '1.5rem' }}
              onClick={() => setStep(3)}
            >
              ← Back
            </button>
          </div>
        )}

        {/* Step 5: Send */}
        {step === 5 && (
          <div>
            {/* User info row */}
            <div style={styles.contactInputRow}>
              <div>
                <label style={styles.contactLabel}>First Name</label>
                <input
                  type="text"
                  placeholder="First name"
                  value={userFirstName}
                  onChange={(e) => {
                    setUserFirstName(e.target.value);
                    if (selectedTemplate) {
                      const fullName = [e.target.value, userLastName].filter(Boolean).join(' ') || '[Your Name]';
                      const msg = selectedTemplate.body
                        .replace(/\{\{NAME\}\}/g, fullName)
                        .replace(/\{\{CITY\}\}/g, userCity || '[Your City]')
                        .replace(/\{\{PHONE\}\}/g, userPhone || '');
                      setCustomMessage(msg);
                    }
                  }}
                  style={{ ...styles.contactInput, marginBottom: 0 }}
                />
              </div>
              <div>
                <label style={styles.contactLabel}>Last Name</label>
                <input
                  type="text"
                  placeholder="Last name"
                  value={userLastName}
                  onChange={(e) => {
                    setUserLastName(e.target.value);
                    if (selectedTemplate) {
                      const fullName = [userFirstName, e.target.value].filter(Boolean).join(' ') || '[Your Name]';
                      const msg = selectedTemplate.body
                        .replace(/\{\{NAME\}\}/g, fullName)
                        .replace(/\{\{CITY\}\}/g, userCity || '[Your City]')
                        .replace(/\{\{PHONE\}\}/g, userPhone || '');
                      setCustomMessage(msg);
                    }
                  }}
                  style={{ ...styles.contactInput, marginBottom: 0 }}
                />
              </div>
              <div>
                <label style={styles.contactLabel}>City</label>
                <input
                  type="text"
                  placeholder="Your city"
                  value={userCity}
                  onChange={(e) => {
                    setUserCity(e.target.value);
                    if (selectedTemplate) {
                      const fullName = [userFirstName, userLastName].filter(Boolean).join(' ') || '[Your Name]';
                      const msg = selectedTemplate.body
                        .replace(/\{\{NAME\}\}/g, fullName)
                        .replace(/\{\{CITY\}\}/g, e.target.value || '[Your City]')
                        .replace(/\{\{PHONE\}\}/g, userPhone || '');
                      setCustomMessage(msg);
                    }
                  }}
                  style={{ ...styles.contactInput, marginBottom: 0 }}
                />
              </div>
              <div>
                <label style={styles.contactLabel}>Phone (optional)</label>
                <input
                  type="tel"
                  placeholder="(605) 555-1234"
                  value={userPhone}
                  onChange={(e) => {
                    setUserPhone(e.target.value);
                    if (selectedTemplate) {
                      const fullName = [userFirstName, userLastName].filter(Boolean).join(' ') || '[Your Name]';
                      const msg = selectedTemplate.body
                        .replace(/\{\{NAME\}\}/g, fullName)
                        .replace(/\{\{CITY\}\}/g, userCity || '[Your City]')
                        .replace(/\{\{PHONE\}\}/g, e.target.value || '');
                      setCustomMessage(msg);
                    }
                  }}
                  style={{ ...styles.contactInput, marginBottom: 0 }}
                />
              </div>
            </div>

            {/* Message */}
            <div style={{ marginBottom: '1rem' }}>
              <label style={styles.contactLabel}>Your Message (edit as needed)</label>
              <textarea
                value={customMessage}
                onChange={(e) => setCustomMessage(e.target.value)}
                style={styles.messageTextarea}
              />
              <p style={{ fontSize: '0.8rem', color: colors.grayMid, marginTop: '0.5rem', fontStyle: 'italic' }}>
                💡 "Dear Senator/Representative [Name]" will be personalized for each legislator when you send.
              </p>
            </div>

            {/* Send to each legislator */}
            <div>
              <label style={styles.contactLabel}>Click each to send:</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem' }}>
                {selectedLegislators.filter(l => l.selected).map((leg) => {
                  const title = leg.chamber === 'Senate' ? 'Senator' : 'Representative';
                  const lastName = leg.name.split(' ').pop();
                  
                  return (
                    <button
                      key={leg.id}
                      onClick={() => openMailto(leg)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0.75rem 1rem',
                        backgroundColor: colors.navyDark,
                        color: 'white',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: '500',
                        fontSize: '1rem',
                        transition: 'background-color 0.2s',
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = colors.navy}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = colors.navyDark}
                    >
                      <span>📧 Email {title} {lastName}</span>
                      <span style={{ opacity: 0.7, fontSize: '0.85rem' }}>{leg.email}</span>
                    </button>
                  );
                })}
              </div>
              <p style={{ fontSize: '0.85rem', color: colors.grayMid, textAlign: 'center', marginBottom: '1rem' }}>
                Click each button to open your email client with the personalized message.
              </p>
            </div>

            {/* Copy button */}
            <button
              style={{ 
                ...styles.modalBtnSecondary, 
                width: '100%',
                marginBottom: '0.75rem',
              }}
              onClick={copyMessage}
            >
              {copied ? '✓ Message Copied!' : '📋 Copy Message to Clipboard'}
            </button>

            <button
              style={{ ...styles.modalBtnSecondary, width: '100%' }}
              onClick={() => setStep(4)}
            >
              ← Back
            </button>
          </div>
        )}

        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: colors.grayMid,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

// Notification Preferences Modal
function NotificationPreferencesModal({ isOpen, onClose, preferences, onSave, loading }) {
  const [localPrefs, setLocalPrefs] = useState(preferences);

  useEffect(() => {
    setLocalPrefs(preferences);
  }, [preferences, isOpen]);

  if (!isOpen) return null;

  const togglePreference = (key) => {
    setLocalPrefs(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    onSave(localPrefs);
  };

  const preferenceOptions = [
    {
      key: 'notify_all_bills',
      label: 'All new bills',
      description: 'Get notified when any new bills are introduced, with a summary and links to view them.',
    },
    {
      key: 'notify_relevant_bills',
      label: 'New insurance-relevant bills',
      description: 'Get notified only when bills that may affect the insurance industry are introduced.',
    },
    {
      key: 'notify_followed_bills',
      label: 'Updates on bills I follow',
      description: 'Get notified when bills you\'re following have status changes or hearings scheduled.',
    },
  ];

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>Notification Preferences</h3>
        <p style={styles.modalSubtitle}>
          Choose what you want to be notified about. We'll send updates to your email when these events occur.
        </p>

        {preferenceOptions.map(option => (
          <div
            key={option.key}
            style={{
              ...styles.preferenceItem,
              ...(localPrefs[option.key] ? styles.preferenceItemActive : {}),
            }}
            onClick={() => togglePreference(option.key)}
          >
            <div style={styles.preferenceHeader}>
              <div style={{
                ...styles.preferenceCheckbox,
                ...(localPrefs[option.key] ? styles.preferenceCheckboxActive : {}),
              }}>
                {localPrefs[option.key] && (
                  <svg width="12" height="12" fill="white" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                )}
              </div>
              <span style={styles.preferenceLabel}>{option.label}</span>
            </div>
            <p style={styles.preferenceDescription}>{option.description}</p>
          </div>
        ))}

        <div style={styles.modalActions}>
          <button style={styles.modalBtnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button 
            style={{
              ...styles.modalBtnPrimary,
              opacity: loading ? 0.7 : 1,
            }} 
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save Preferences'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Calendar Modal Component
function CalendarModal({ isOpen, onClose, events, onRemoveEvent, onDownloadIcs }) {
  if (!isOpen) return null;

  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const isDateTodayOrFuture = (d) => d >= todayStart;

  // Filter to show today's and future events (even if time has passed today)
  const upcomingEvents = events.filter(event => isDateTodayOrFuture(new Date(event.event_date)));
  const pastEvents = events.filter(event => !isDateTodayOrFuture(new Date(event.event_date)));

  // Group upcoming events by date
  const groupedEvents = upcomingEvents.reduce((acc, event) => {
    const eventDate = new Date(event.event_date);
    const today = new Date();
    const isToday = eventDate.toDateString() === today.toDateString();
    const dateKey = isToday 
      ? 'Today' 
      : eventDate.toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        });
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(event);
    return acc;
  }, {});

  // Sort dates, with "Today" first
  const sortedDates = Object.keys(groupedEvents).sort((a, b) => {
    if (a === 'Today') return -1;
    if (b === 'Today') return 1;
    return new Date(groupedEvents[a][0].event_date) - new Date(groupedEvents[b][0].event_date);
  });

  const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  const generateIcsContent = (event) => {
    const startDate = new Date(event.event_date);
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // 1 hour duration
    
    const formatIcsDate = (date) => {
      return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };

    const escapeIcs = (str) => {
      return (str || '').replace(/[,;\\]/g, '\\$&').replace(/\n/g, '\\n');
    };

    return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//SD Legislative Tracker//EN
BEGIN:VEVENT
DTSTART:${formatIcsDate(startDate)}
DTEND:${formatIcsDate(endDate)}
SUMMARY:${escapeIcs(event.bill_number)} – ${escapeIcs(event.event_type)} (${escapeIcs(event.committee)})
DESCRIPTION:${escapeIcs(event.bill_title)}\\n\\nView bill: https://sdlegislature.gov/Session/Bill/${event.bill_id}
LOCATION:${escapeIcs(event.location || 'South Dakota State Capitol')}
BEGIN:VALARM
TRIGGER:-P1D
DESCRIPTION:Hearing tomorrow: ${escapeIcs(event.bill_number)}
ACTION:DISPLAY
END:VALARM
BEGIN:VALARM
TRIGGER:-PT1H
DESCRIPTION:Hearing in 1 hour: ${escapeIcs(event.bill_number)}
ACTION:DISPLAY
END:VALARM
END:VEVENT
END:VCALENDAR`;
  };

  const handleDownloadIcs = (event) => {
    const icsContent = generateIcsContent(event);
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${event.bill_number.replace(/\s+/g, '')}-hearing.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleDownloadAll = () => {
    upcomingEvents.forEach(event => handleDownloadIcs(event));
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={{ ...styles.modal, maxWidth: '600px', maxHeight: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3 style={{ ...styles.modalTitle, marginBottom: 0 }}>📅 My Calendar</h3>
          {upcomingEvents.length > 0 && (
            <button
              onClick={handleDownloadAll}
              style={{
                background: 'none',
                border: `1px solid ${colors.border}`,
                borderRadius: '6px',
                padding: '0.5rem 0.75rem',
                fontSize: '0.85rem',
                color: colors.grayDark,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.35rem',
              }}
            >
              <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Export All
            </button>
          )}
        </div>
        
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {upcomingEvents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: colors.grayMid }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📭</div>
              <p>No upcoming events in your calendar.</p>
              <p style={{ fontSize: '0.9rem' }}>Click "+ Add to Calendar" on any hearing to add it here.</p>
              {pastEvents.length > 0 && (
                <p style={{ fontSize: '0.85rem', marginTop: '1rem', color: colors.grayMid }}>
                  ({pastEvents.length} past event{pastEvents.length > 1 ? 's' : ''} hidden)
                </p>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {sortedDates.map(dateKey => (
                <div key={dateKey}>
                  <div style={{
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    color: dateKey === 'Today' ? colors.orange : colors.navy,
                    marginBottom: '0.5rem',
                    paddingBottom: '0.25rem',
                    borderBottom: `2px solid ${dateKey === 'Today' ? colors.orange : colors.navy}`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}>
                    {dateKey === 'Today' && <span>🔴</span>}
                    {dateKey}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {groupedEvents[dateKey]
                      .sort((a, b) => new Date(a.event_date) - new Date(b.event_date))
                      .map(event => (
                        <div
                          key={event.id}
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '0.75rem',
                            padding: '0.75rem',
                            backgroundColor: colors.grayLight,
                            borderRadius: '6px',
                            borderLeft: `3px solid ${colors.orange}`,
                          }}
                        >
                          <div style={{
                            fontWeight: '600',
                            fontSize: '0.85rem',
                            color: colors.orange,
                            minWidth: '70px',
                          }}>
                            {formatTime(event.event_date)}
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: '600', color: colors.navyDark }}>
                              {event.bill_number}
                            </div>
                            <div style={{ fontSize: '0.85rem', color: colors.grayMid }}>
                              {event.event_type} • {event.committee}
                            </div>
                            {event.bill_title && (
                              <div style={{ fontSize: '0.8rem', color: colors.grayMid, marginTop: '0.25rem' }}>
                                {event.bill_title.length > 80 ? event.bill_title.substring(0, 80) + '...' : event.bill_title}
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <button
                              onClick={() => handleDownloadIcs(event)}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: colors.grayMid,
                                padding: '0.25rem',
                                borderRadius: '4px',
                              }}
                              title="Download .ics file"
                            >
                              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                            </button>
                            <button
                              onClick={() => onRemoveEvent(event.id)}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: colors.danger,
                                padding: '0.25rem',
                                borderRadius: '4px',
                              }}
                              title="Remove from calendar"
                            >
                              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: `1px solid ${colors.border}` }}>
          <button style={{ ...styles.modalBtnSecondary, width: '100%' }} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

// Notification Banner Component - only shows when no preferences set
function NotificationBanner({ preferences, onOpenSettings, loading }) {
  // Don't show banner while loading preferences
  if (loading) {
    return null;
  }

  const hasAnyPreference = preferences.notify_all_bills || 
                           preferences.notify_relevant_bills || 
                           preferences.notify_followed_bills;

  // Don't show banner if user has already set up notifications
  if (hasAnyPreference) {
    return null;
  }

  return (
    <div style={styles.notificationBanner}>
      <div style={styles.notificationBannerLeft}>
        <span style={styles.notificationIcon}>📬</span>
        <div style={styles.notificationBannerText}>
          <div style={styles.notificationBannerTitle}>
            Get notified when new bills drop
          </div>
          <div style={styles.notificationBannerSubtitle}>
            Stay informed about new legislation and updates to bills you're tracking
          </div>
        </div>
      </div>
      <button style={styles.notificationBannerBtn} onClick={onOpenSettings}>
        Set up notifications
      </button>
    </div>
  );
}

// Bill Card Component
function BillCard({ bill, user, followedBills, onToggleFollow, initialExpanded = false, onAddToCalendar, isEventInCalendar, onShowToast }) {
  const [expanded, setExpanded] = useState(initialExpanded);
  const [otherStatesOpen, setOtherStatesOpen] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const cardRef = React.useRef(null);
  
  // Scroll into view if initially expanded (from URL parameter)
  useEffect(() => {
    if (initialExpanded && cardRef.current) {
      setTimeout(() => {
        cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [initialExpanded]);
  
  const isFollowing = followedBills.has(bill.bill_id);
  
  const analysis = bill.analysis || {};
  const isRelevant = analysis.relevant;
  const confidence = analysis.confidence;
  
  let badgeStyle = { ...styles.badge };
  let badgeText = 'Not Relevant';
  
  if (isRelevant) {
    badgeStyle = { ...styles.badge, ...styles.badgeRelevant };
    badgeText = 'Relevant';
  } else if (confidence === 'low') {
    badgeStyle = { ...styles.badge, ...styles.badgeMaybe };
    badgeText = 'Review';
  } else {
    badgeStyle = { ...styles.badge, ...styles.badgeNotRelevant };
  }

  // Get stage badge info
  const getStageBadge = () => {
    const stageInfo = {
      introduced: { label: 'Introduced', color: colors.grayMid },
      committee: { label: 'In Committee', color: colors.navy },
      floor: { label: 'On Floor', color: colors.orange },
      passed_first: { label: 'Passed 1st Chamber', color: colors.greenLight },
      passed_second: { label: 'Passed Both', color: colors.green },
      enacted: { label: 'Passed', color: '#28a745' },
      vetoed: { label: 'Killed', color: colors.danger },
      dead: { label: 'Killed', color: colors.danger },
    };
    return stageInfo[bill.stage] || null;
  };

  const stageBadge = getStageBadge();

  const hasCrossStateContent = bill.cross_state_analysis && (
    bill.cross_state_analysis.summary ||
    bill.cross_state_analysis.outcomes ||
    bill.cross_state_analysis.support_opposition ||
    (bill.similar_bills && bill.similar_bills.length > 0)
  );

  const formatHearingDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { 
        weekday: 'short', 
        month: 'short', 
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    } catch {
      return dateStr;
    }
  };

  const formatActionDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  };

  // Check for upcoming events (include all of today's events)
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const isDateTodayOrFuture = (d) => d >= todayStart;

  const upcomingEvents = (bill.upcoming_events || []).filter(e => isDateTodayOrFuture(new Date(e.date)));
  const hasUpcomingEvents = upcomingEvents.length > 0 || (bill.hearing_date && isDateTodayOrFuture(new Date(bill.hearing_date)));

  // Get next event date for inline display
  const getNextEventInfo = () => {
    let nextDate = null;
    let eventType = 'Hearing';
    let committee = null;
    let eventData = null;

    if (bill.hearing_date) {
      const d = new Date(bill.hearing_date);
      if (isDateTodayOrFuture(d)) {
        nextDate = d;
        eventType = 'Committee Hearing';
        committee = bill.committee;
        eventData = {
          date: bill.hearing_date,
          type: 'Committee Hearing',
          committee: bill.committee,
          location: bill.hearing_location,
        };
      }
    }

    if (bill.upcoming_events) {
      for (const event of bill.upcoming_events) {
        const d = new Date(event.date);
        if (isDateTodayOrFuture(d) && (!nextDate || d < nextDate)) {
          nextDate = d;
          eventType = event.type || 'Committee Hearing';
          committee = event.committee;
          eventData = event;
        }
      }
    }

    if (bill.floor_scheduled) {
      const d = new Date(bill.floor_scheduled);
      if (isDateTodayOrFuture(d) && (!nextDate || d < nextDate)) {
        nextDate = d;
        eventType = 'Floor Vote';
        committee = null;
        eventData = {
          date: bill.floor_scheduled,
          type: 'Floor Vote',
          committee: null,
          location: null,
        };
      }
    }

    return nextDate ? { date: nextDate, type: eventType, committee, eventData } : null;
  };

  const nextEvent = getNextEventInfo();
  const nextEventInCalendar = nextEvent && isEventInCalendar && isEventInCalendar(bill.bill_id, nextEvent.eventData?.date);

  const handleFollowClick = async (e) => {
    e.stopPropagation();
    if (followLoading) return;
    
    setFollowLoading(true);
    await onToggleFollow(bill.bill_id, bill.bill_number, isFollowing);
    setFollowLoading(false);
  };

  return (
    <div 
      ref={cardRef}
      className="bill-card"
      style={{
        ...styles.billCard,
        ...(isRelevant ? { borderLeft: `4px solid ${colors.green}` } : {}),
        ...(initialExpanded ? { boxShadow: `0 0 0 2px ${colors.orange}` } : {}),
      }}
    >
      <div 
        className="bill-header"
        style={styles.billHeader} 
        onClick={() => setExpanded(!expanded)}
      >
        <div className="bill-header-left" style={styles.billHeaderLeft}>
          <div className="bill-number" style={styles.billNumber}>
            {bill.bill_number}
            {confidence && (
              <span className="badge" style={styles.badgeConfidence}>({confidence} confidence)</span>
            )}

          </div>
          <div className="bill-title" style={styles.billTitle}>{bill.title}</div>
        </div>
        <div className="bill-header-right bill-badges" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          {stageBadge && (
            <span className="badge" style={{
              ...styles.badge,
              backgroundColor: stageBadge.color + '20',
              color: stageBadge.color,
              border: `1px solid ${stageBadge.color}40`,
            }}>
              {stageBadge.label}
            </span>
          )}
          <span className="badge" style={badgeStyle}>{badgeText}</span>
          <span style={{
            ...styles.expandIcon,
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}>▼</span>
        </div>
      </div>
      
      {/* Status bar with committee info */}
      {(bill.status || bill.hearing_date || bill.committee) && (
        <div className="bill-meta" style={styles.statusBar}>
          {bill.committee && (
            <div className="committee-badge" style={{
              ...styles.statusItem,
              backgroundColor: colors.navy + '10',
              padding: '0.25rem 0.5rem',
              borderRadius: '4px',
            }}>
              <svg style={{ ...styles.statusIcon, color: colors.navy }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span><strong>{bill.committee}</strong></span>
            </div>
          )}
          {bill.status && !bill.committee && (
            <div style={styles.statusItem}>
              <svg style={styles.statusIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span><strong>Status:</strong> {bill.status}</span>
            </div>
          )}
          {bill.last_action && (
            <div style={styles.statusItem}>
              <span style={{ color: colors.grayMid }}>
                Last action: {bill.last_action}
                {bill.last_action_date && ` (${new Date(bill.last_action_date).toLocaleDateString()})`}
              </span>
            </div>
          )}
       {hasUpcomingEvents && nextEvent && (
            <div className="hearing-info" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
            }}>
              <div className="hearing-date" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0.75rem',
                backgroundColor: colors.orange + '15',
                borderRadius: '6px',
                fontSize: '0.8rem',
                color: colors.orange,
                fontWeight: '500',
              }}>
                <svg style={{ width: '14px', height: '14px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {nextEvent.type}: {new Date(nextEvent.date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}, {new Date(nextEvent.date).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
              </div>

              {onAddToCalendar && (
                <button
                  className="add-calendar-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!nextEventInCalendar && nextEvent.eventData) {
                      onAddToCalendar(bill, nextEvent.eventData);
                    }
                  }}
                  disabled={nextEventInCalendar}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: nextEventInCalendar ? colors.green : colors.grayMid,
                    cursor: nextEventInCalendar ? 'default' : 'pointer',
                    fontSize: '0.8rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                  }}
                >
                  {nextEventInCalendar ? '✓ Added' : '+ Add to Calendar'}
                </button>
              )}
            </div>
          )}
        </div>
      )}
      
      {expanded && (
        <div className="bill-details" style={styles.billDetails}>
          <div className="action-buttons" style={styles.actionButtons}>
            <a 
              href={bill.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={styles.linkButton}
            >
              View on SD Legislature →
            </a>
            <button
              onClick={handleFollowClick}
              disabled={followLoading}
              style={{
                ...styles.followButton,
                ...(isFollowing ? styles.followButtonFollowing : styles.followButtonDefault),
                ...(followLoading ? styles.followButtonLoading : {}),
              }}
            >
              {followLoading ? (
                'Updating...'
              ) : isFollowing ? (
                <>
                  <svg style={{ width: '16px', height: '16px' }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Following
                </>
              ) : (
                <>
                  <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                  Follow
                </>
              )}
            </button>
            {isRelevant && bill.analysis?.email_templates && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setContactModalOpen(true);
                }}
                style={styles.contactButton}
              >
                <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Contact Legislators
              </button>
            )}
            <button
              onClick={(e) => {
                e.stopPropagation();
                const url = `${window.location.origin}${window.location.pathname}?bill=${bill.bill_id}`;
                navigator.clipboard.writeText(url).then(() => {
                  if (onShowToast) onShowToast(`Link copied for ${bill.bill_number}`);
                });
              }}
              style={{
                ...styles.followButton,
                ...styles.followButtonDefault,
                gap: '0.5rem',
              }}
            >
              <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
              Share
            </button>
          </div>
          
          {analysis.bill_summary && (
            <div className="section" style={styles.section}>
              <div className="section-title" style={styles.sectionTitle}>
                <svg style={styles.sectionIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                What This Bill Does
              </div>
              <div className="section-content" style={styles.sectionContent}>{analysis.bill_summary}</div>
            </div>
          )}
          
          {analysis.insurance_impact && analysis.insurance_impact !== 'None' && (
            <div className="section" style={styles.section}>
              <div className="section-title" style={styles.sectionTitle}>
                <svg style={styles.sectionIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Impact on the Insurance Industry
              </div>
              <div className="section-content" style={styles.sectionContent}>{analysis.insurance_impact}</div>
            </div>
          )}

          {/* Upcoming Events Section */}
          {upcomingEvents.length > 0 && (
            <div className="section" style={{
              ...styles.section,
              backgroundColor: colors.orange + '10',
              borderRadius: '8px',
              padding: '1rem',
              border: `1px solid ${colors.orange}30`,
            }}>
              <div className="section-title" style={styles.sectionTitle}>
                <svg style={styles.sectionIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Upcoming Events
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {upcomingEvents.slice(0, 5).map((event, idx) => {
                  const inCalendar = isEventInCalendar && isEventInCalendar(bill.bill_id, event.date);
                  return (
                    <div key={idx} style={{
                      padding: '0.75rem',
                      backgroundColor: colors.white,
                      borderRadius: '6px',
                      fontSize: '0.9rem',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                        <span style={{
                          backgroundColor: colors.orange,
                          color: colors.white,
                          padding: '0.25rem 0.5rem',
                          borderRadius: '4px',
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          whiteSpace: 'nowrap',
                        }}>
                          {formatHearingDate(event.date)}
                        </span>
                        <span style={{ fontWeight: '500' }}>{event.type || 'Hearing'}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ color: colors.grayMid, fontSize: '0.85rem' }}>
                          {event.committee}
                          {event.location && ` • ${event.location}`}
                        </span>
                        {onAddToCalendar && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!inCalendar) {
                                onAddToCalendar(bill, event);
                              }
                            }}
                            disabled={inCalendar}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: inCalendar ? colors.green : colors.grayMid,
                              cursor: inCalendar ? 'default' : 'pointer',
                              fontSize: '0.8rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              transition: 'background-color 0.15s',
                            }}
                            onMouseEnter={(e) => { if (!inCalendar) e.target.style.backgroundColor = colors.grayLight; }}
                            onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
                          >
                            {inCalendar ? (
                              <>✓ In Calendar</>
                            ) : (
                              <>+ Add to Calendar</>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/* Action History Section */}
          {bill.actions && bill.actions.length > 0 && (
            <>
              <div 
                style={styles.collapsibleHeader}
                onClick={() => setActionsOpen(!actionsOpen)}
              >
                <span style={styles.collapsibleHeaderText}>
                  <svg style={styles.sectionIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Action History ({bill.actions.length})
                </span>
                <span style={{
                  ...styles.collapsibleIcon,
                  transform: actionsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}>▼</span>
              </div>
              
              {actionsOpen && (
                <div style={styles.collapsibleContent}>
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '0.5rem',
                    maxHeight: '300px',
                    overflowY: 'auto',
                  }}>
                    {bill.actions.map((action, idx) => (
                      <div key={idx} style={{
                        display: 'flex',
                        gap: '1rem',
                        padding: '0.5rem',
                        backgroundColor: idx === 0 ? colors.greenPale : colors.grayLight,
                        borderRadius: '6px',
                        fontSize: '0.875rem',
                        borderLeft: idx === 0 ? `3px solid ${colors.green}` : 'none',
                      }}>
                        <span style={{
                          minWidth: '90px',
                          color: colors.grayMid,
                          fontWeight: '500',
                        }}>
                          {formatActionDate(action.date)}
                        </span>
                        <span style={{ flex: 1 }}>
                          {action.description}
                          {action.chamber && (
                            <span style={{ 
                              marginLeft: '0.5rem',
                              fontSize: '0.75rem',
                              color: colors.navy,
                              backgroundColor: colors.navy + '15',
                              padding: '0.125rem 0.375rem',
                              borderRadius: '3px',
                            }}>
                              {action.chamber}
                            </span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          
          {hasCrossStateContent && (
            <>
              <div 
                style={styles.collapsibleHeader}
                onClick={() => setOtherStatesOpen(!otherStatesOpen)}
              >
                <span style={styles.collapsibleHeaderText}>
                  <svg style={styles.sectionIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  What Other States Are Doing
                </span>
                <span style={{
                  ...styles.collapsibleIcon,
                  transform: otherStatesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}>▼</span>
              </div>
              
              {otherStatesOpen && (
                <div style={styles.collapsibleContent}>
                  {bill.cross_state_analysis?.summary && (
                    <div style={styles.subsection}>
                      <div style={styles.subsectionTitle}>How Other States Have Approached This</div>
                      <div style={styles.sectionContent}>{bill.cross_state_analysis.summary}</div>
                    </div>
                  )}
                  
                  {bill.cross_state_analysis?.outcomes && (
                    <div style={styles.subsection}>
                      <div style={styles.subsectionTitle}>Outcomes in Other States</div>
                      <div style={styles.sectionContent}>{bill.cross_state_analysis.outcomes}</div>
                    </div>
                  )}
                  
                  {bill.cross_state_analysis?.support_opposition && (
                    <div style={styles.subsection}>
                      <div style={styles.subsectionTitle}>Who Supports & Opposes</div>
                      <div style={styles.sectionContent}>{bill.cross_state_analysis.support_opposition}</div>
                    </div>
                  )}
                  
                  {bill.similar_bills && bill.similar_bills.length > 0 && (
                    <div style={styles.subsectionLast}>
                      <div style={styles.subsectionTitle}>Similar Bills ({bill.similar_bills.length})</div>
                      <div style={styles.similarBillsGrid}>
                        {bill.similar_bills.slice(0, 5).map((sb, idx) => (
                          <div key={idx} style={styles.similarBill}>
                            <div style={styles.similarBillHeader}>
                              <span style={styles.similarBillState}>{sb.state} {sb.bill_number}</span>
                              <span style={styles.similarBillStatus}>{sb.last_action_date}</span>
                            </div>
                            <div style={styles.similarBillTitle}>{sb.title}</div>
                            <div style={{ fontSize: '0.75rem', color: colors.grayMid, marginTop: '0.5rem' }}>
                              {sb.last_action}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          
          {analysis.keywords && analysis.keywords.length > 0 && (
            <div style={styles.section}>
              <div style={styles.sectionTitle}>Keywords</div>
              <div style={styles.keywordsContainer}>
                {analysis.keywords.map((kw, idx) => (
                  <span key={idx} style={styles.keyword}>{kw}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      
      <ContactLegislatorModal
        isOpen={contactModalOpen}
        onClose={() => setContactModalOpen(false)}
        bill={bill}
      />
    </div>
  );
}

// Dashboard Component
function Dashboard({ user, session, onLogout }) {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [sortBy, setSortBy] = useState('upcoming');
  const [searchQuery, setSearchQuery] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);
  const [followedBills, setFollowedBills] = useState(new Set());
  const [showPrefsModal, setShowPrefsModal] = useState(false);
  const [notificationPrefs, setNotificationPrefs] = useState({
    notify_all_bills: false,
    notify_relevant_bills: false,
    notify_followed_bills: false,
  });
  const [loadingPrefs, setLoadingPrefs] = useState(true);
  const [savingPrefs, setSavingPrefs] = useState(false);
  const [highlightedBillId, setHighlightedBillId] = useState(null);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const BILLS_PER_PAGE = 30;
  const [toast, setToast] = useState(null);

  // Check URL for bill parameter on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const billParam = params.get('bill');
    if (billParam) {
      setHighlightedBillId(parseInt(billParam, 10));
      setFilter('all');
      setSearchQuery('');
    }
  }, []);

  // Reset to page 1 when filter, search, or sort changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filter, searchQuery, sortBy]);

  // Fetch notification preferences
  const fetchNotificationPrefs = useCallback(async () => {
    if (!supabase || !user) {
      setLoadingPrefs(false);
      return;
    }
    
    try {
      const { data, error } = await supabase
        .from('subscribers')
        .select('notify_all_bills, notify_relevant_bills, notify_followed_bills')
        .eq('id', user.id)
        .single();
      
      if (error && error.code !== 'PGRST116') throw error;
      
      if (data) {
        setNotificationPrefs({
          notify_all_bills: data.notify_all_bills || false,
          notify_relevant_bills: data.notify_relevant_bills || false,
          notify_followed_bills: data.notify_followed_bills || false,
        });
      }
    } catch (err) {
      console.error('Error fetching notification preferences:', err);
    } finally {
      setLoadingPrefs(false);
    }
  }, [user]);

  // Save notification preferences
  const saveNotificationPrefs = async (newPrefs) => {
    if (!supabase || !user) return;
    
    setSavingPrefs(true);
    try {
      const { error } = await supabase
        .from('subscribers')
        .update({
          notify_all_bills: newPrefs.notify_all_bills,
          notify_relevant_bills: newPrefs.notify_relevant_bills,
          notify_followed_bills: newPrefs.notify_followed_bills,
          updated_at: new Date().toISOString(),
        })
        .eq('id', user.id);
      
      if (error) throw error;
      
      setNotificationPrefs(newPrefs);
      setShowPrefsModal(false);
    } catch (err) {
      console.error('Error saving notification preferences:', err);
    }
    setSavingPrefs(false);
  };

  // Fetch followed bills for this user
  const fetchFollowedBills = useCallback(async () => {
    if (!supabase || !user) return;
    
    try {
      const { data, error } = await supabase
        .from('followed_bills')
        .select('bill_id')
        .eq('subscriber_id', user.id);
      
      if (error) throw error;
      
      const billIds = new Set(data.map(fb => fb.bill_id));
      setFollowedBills(billIds);
    } catch (err) {
      console.error('Error fetching followed bills:', err);
    }
  }, [user]);

  // Fetch calendar events for this user
  const fetchCalendarEvents = useCallback(async () => {
    if (!supabase || !user) return;
    
    try {
      const { data, error } = await supabase
        .from('user_calendar_events')
        .select('*')
        .eq('user_id', user.id)
        .order('event_date', { ascending: true });
      
      if (error) throw error;
      setCalendarEvents(data || []);
    } catch (err) {
      console.error('Error fetching calendar events:', err);
    }
  }, [user]);

  // Add event to calendar
  const addToCalendar = async (bill, event) => {
    if (!supabase || !user) return;
    
    try {
      const { error } = await supabase
        .from('user_calendar_events')
        .insert({
          user_id: user.id,
          bill_id: bill.bill_id,
          bill_number: bill.bill_number,
          bill_title: bill.title,
          event_date: event.date,
          event_type: event.type || 'Committee Hearing',
          committee: event.committee,
          location: event.location,
        });
      
      if (error) {
        if (error.code === '23505') {
          // Duplicate - already in calendar
          alert('This event is already in your calendar');
          return;
        }
        throw error;
      }
      
      // Refresh calendar events
      fetchCalendarEvents();

      // Show toast with download option
      showToast('Added to calendar', {
        label: 'Download ICS',
        onClick: () => downloadICS(bill, event)
      });
    } catch (err) {
      console.error('Error adding to calendar:', err);
    }
  };

  // Remove event from calendar
  const removeFromCalendar = async (eventId) => {
    if (!supabase || !user) return;
    
    try {
      const { error } = await supabase
        .from('user_calendar_events')
        .delete()
        .eq('id', eventId)
        .eq('user_id', user.id);
      
      if (error) throw error;
      
      fetchCalendarEvents();
    } catch (err) {
      console.error('Error removing from calendar:', err);
    }
  };

  // Generate and download ICS file
  const downloadICS = (bill, event) => {
    const eventDate = new Date(event.date);
    const endDate = new Date(eventDate.getTime() + 60 * 60 * 1000); // 1 hour duration
    
    const formatICSDate = (date) => {
      return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };
    
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//SD Legislative Monitor//EN
BEGIN:VEVENT
UID:${bill.bill_id}-${eventDate.getTime()}@sdlegmonitor
DTSTART:${formatICSDate(eventDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:${bill.bill_number} – ${event.type || 'Committee Hearing'}${event.committee ? ` (${event.committee})` : ''}
DESCRIPTION:${bill.title}\\n\\nView bill: ${bill.url}
LOCATION:${event.location || 'South Dakota State Capitol'}
BEGIN:VALARM
TRIGGER:-P1D
DESCRIPTION:Hearing tomorrow: ${bill.bill_number}
ACTION:DISPLAY
END:VALARM
BEGIN:VALARM
TRIGGER:-PT1H
DESCRIPTION:Hearing in 1 hour: ${bill.bill_number}
ACTION:DISPLAY
END:VALARM
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${bill.bill_number.replace(/\s+/g, '')}-hearing.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Show toast notification
  const showToast = (message, action = null) => {
    setToast({ message, action });
    setTimeout(() => setToast(null), 5000);
  };

  // Check if event is in user's calendar
  const isEventInCalendar = (billId, eventDate) => {
    return calendarEvents.some(e => 
      e.bill_id === billId && 
      new Date(e.event_date).getTime() === new Date(eventDate).getTime()
    );
  };

  useEffect(() => {
    const fetchBills = async () => {
      try {
        const response = await fetch('/bills.json?t=' + Date.now());
        const data = await response.json();
        setBills(data.bills || []);
        setLastUpdated(data.last_updated);
      } catch (error) {
        console.error('Error fetching bills:', error);
        setBills([]);
      }
      setLoading(false);
    };

    fetchBills();
    fetchFollowedBills();
    fetchCalendarEvents();
    fetchNotificationPrefs();
  }, [fetchFollowedBills, fetchCalendarEvents, fetchNotificationPrefs]);

  const handleToggleFollow = async (billId, billNumber, currentlyFollowing) => {
    if (!supabase || !user) return;

    try {
      if (currentlyFollowing) {
        // Unfollow
        const { error } = await supabase
          .from('followed_bills')
          .delete()
          .eq('subscriber_id', user.id)
          .eq('bill_id', billId);
        
        if (error) throw error;
        
        setFollowedBills(prev => {
          const next = new Set(prev);
          next.delete(billId);
          return next;
        });
      } else {
        // Follow
        const { error } = await supabase
          .from('followed_bills')
          .insert({
            subscriber_id: user.id,
            bill_id: billId,
            bill_number: billNumber,
          });
        
        if (error) throw error;
        
        setFollowedBills(prev => new Set([...prev, billId]));
      }
    } catch (err) {
      console.error('Error toggling follow:', err);
      // Could add error toast here
    }
  };

  const handleLogout = async () => {
    if (supabase) {
      await supabase.auth.signOut();
    }
    onLogout();
  };

  // Search filter function
  const matchesSearch = (bill) => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    const queryNoSpaces = query.replace(/\s+/g, '');
    
    // Normalize bill number for comparison (remove spaces)
    const billNumber = (bill.bill_number || '').toLowerCase();
    const billNumberNoSpaces = billNumber.replace(/\s+/g, '');
    
    // Check bill number with both formats
    if (billNumber.includes(query) || billNumberNoSpaces.includes(queryNoSpaces)) {
      return true;
    }
    
    // Check committee
    if (bill.committee && bill.committee.toLowerCase().includes(query)) {
      return true;
    }
    
    // Check other fields
    const searchableText = [
      bill.title,
      bill.description,
      bill.analysis?.summary,
      bill.analysis?.bill_summary,
      bill.analysis?.impact,
      bill.analysis?.insurance_impact,
      bill.analysis?.recommendation,
      bill.analysis?.reason,
      ...(bill.analysis?.keywords || []),
    ].filter(Boolean).join(' ').toLowerCase();
    
    return searchableText.includes(query);
  };

  // Count bills with upcoming events (include all of today's events)
  const upcomingEventsCount = React.useMemo(() => {
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const isDateTodayOrFuture = (d) => d >= todayStart;
    return bills.filter(bill => {
      if (bill.hearing_date) {
        const hearingDate = new Date(bill.hearing_date);
        return isDateTodayOrFuture(hearingDate);
      }
      if (bill.upcoming_events && bill.upcoming_events.length > 0) {
        return bill.upcoming_events.some(e => isDateTodayOrFuture(new Date(e.date)));
      }
      return false;
    }).length;
  }, [bills]);

  const filteredBills = bills.filter(bill => {
    // First apply search filter
    if (!matchesSearch(bill)) return false;
    
    // Apply category filter
    if (filter === 'relevant' && bill.analysis?.relevant !== true) return false;
    if (filter === 'following' && !followedBills.has(bill.bill_id)) return false;
    
    return true;
  });

  const sortedBills = [...filteredBills].sort((a, b) => {
    if (sortBy === 'relevance') {
      // Sort by relevance and confidence: high relevant > medium relevant > low relevant > not relevant
      const getRelevanceScore = (bill) => {
        if (!bill.analysis?.relevant) return 0;
        const confidence = bill.analysis?.confidence;
        if (confidence === 'high') return 3;
        if (confidence === 'medium') return 2;
        return 1; // low confidence
      };
      const scoreA = getRelevanceScore(a);
      const scoreB = getRelevanceScore(b);
      if (scoreA !== scoreB) return scoreB - scoreA;
      // Same relevance score, sort by date (newest first)
      const dateA = new Date(a.processed_at || 0);
      const dateB = new Date(b.processed_at || 0);
      return dateB - dateA;
    }
    if (sortBy === 'oldest') {
      // Oldest first
      const dateA = new Date(a.processed_at || 0);
      const dateB = new Date(b.processed_at || 0);
      return dateA - dateB;
    }
    if (sortBy === 'upcoming') {
      // Sort by next event date (soonest first), bills without events at bottom
      // Include all of today's events even if start time has passed
      const getNextEventDate = (bill) => {
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const isDateTodayOrFuture = (d) => d >= todayStart;
        let nextDate = null;

        if (bill.hearing_date) {
          const d = new Date(bill.hearing_date);
          if (isDateTodayOrFuture(d)) nextDate = d;
        }

        if (bill.upcoming_events) {
          for (const event of bill.upcoming_events) {
            const d = new Date(event.date);
            if (isDateTodayOrFuture(d) && (!nextDate || d < nextDate)) {
              nextDate = d;
            }
          }
        }

        if (bill.floor_scheduled) {
          const d = new Date(bill.floor_scheduled);
          if (isDateTodayOrFuture(d) && (!nextDate || d < nextDate)) {
            nextDate = d;
          }
        }

        return nextDate;
      };
      
      const dateA = getNextEventDate(a);
      const dateB = getNextEventDate(b);
      
      // Bills with events come first, sorted by soonest
      if (dateA && !dateB) return -1;
      if (!dateA && dateB) return 1;
      if (dateA && dateB) return dateA - dateB;
      
      // Neither has events - sort by relevance, then by newest
      const getRelevanceScore = (bill) => {
        if (!bill.analysis?.relevant) return 0;
        const confidence = bill.analysis?.confidence;
        if (confidence === 'high') return 3;
        if (confidence === 'medium') return 2;
        return 1;
      };
      const scoreA = getRelevanceScore(a);
      const scoreB = getRelevanceScore(b);
      if (scoreA !== scoreB) return scoreB - scoreA;
      
      // Same relevance, sort by newest
      const procA = new Date(a.processed_at || 0);
      const procB = new Date(b.processed_at || 0);
      return procB - procA;
    }
    if (sortBy === 'committee') {
      // Sort alphabetically by committee
      const commA = (a.committee || 'zzz').toLowerCase();
      const commB = (b.committee || 'zzz').toLowerCase();
      return commA.localeCompare(commB);
    }
    // Default (newest): newest first
    const dateA = new Date(a.processed_at || 0);
    const dateB = new Date(b.processed_at || 0);
    return dateB - dateA;
  });

  const relevantCount = bills.filter(b => b.analysis?.relevant).length;
  const followingCount = followedBills.size;

  // Jump to the correct page when a highlighted bill is set
  useEffect(() => {
    if (highlightedBillId && sortedBills.length > 0) {
      const idx = sortedBills.findIndex(b => b.bill_id === highlightedBillId);
      if (idx >= 0) {
        const targetPage = Math.floor(idx / BILLS_PER_PAGE) + 1;
        setCurrentPage(targetPage);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightedBillId, sortedBills.length]);

  // Pagination
  const totalPages = Math.ceil(sortedBills.length / BILLS_PER_PAGE);
  const startIndex = (currentPage - 1) * BILLS_PER_PAGE;
  const paginatedBills = sortedBills.slice(startIndex, startIndex + BILLS_PER_PAGE);

  if (loading) {
    return (
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.headerContent}>
            <div style={styles.logoContainer}>
              <span style={styles.logo}>
                <span style={styles.logoAccent}>IIASD</span> Legislative Monitor
              </span>
            </div>
          </div>
        </header>
        <div style={styles.loading}>
          <div style={styles.loadingSpinner}></div>
          <p>Loading bills...</p>
        </div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div className="header-content" style={styles.headerContent}>
          <div style={styles.logoContainer}>
            <span style={styles.logo}>
              <span style={styles.logoAccent}>IIASD</span> Legislative Monitor
            </span>
            <span className="logo-subtext" style={styles.logoSubtext}>101st Session (2026)</span>
          </div>
          <div className="header-right" style={styles.userInfo}>
            <span style={styles.userEmail}>{user.email}</span>
            <button 
              onClick={() => setShowPrefsModal(true)}
              style={styles.settingsBtn}
              title="Notification settings"
            >
              <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
            <button 
              onClick={handleLogout} 
              style={styles.logoutBtn}
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>
      
      <main className="main-content" style={styles.main}>
        <div className="page-header" style={styles.pageHeader}>
          <h1 className="page-title" style={styles.pageTitle}>South Dakota Legislative Tracking</h1>
          <p className="page-subtitle" style={styles.pageSubtitle}>
            AI-powered analysis of bills affecting independent insurance agents
          </p>
        </div>
        
        {lastUpdated && (
          <div style={styles.lastUpdated}>
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Last updated: {new Date(lastUpdated).toLocaleString()}
          </div>
        )}

        <NotificationBanner 
          preferences={notificationPrefs} 
          onOpenSettings={() => setShowPrefsModal(true)}
          loading={loadingPrefs}
        />
        
        <div className="stats-grid" style={styles.statsGrid}>
          <div className="stat-card" style={styles.statCard}>
            <div className="stat-number" style={styles.statNumber}>{bills.length}</div>
            <div style={styles.statLabel}>Total Bills Tracked</div>
          </div>
          <div className="stat-card" style={{ ...styles.statCard, ...styles.statCardRelevant }}>
            <div className="stat-number" style={{ ...styles.statNumber, color: colors.green }}>{relevantCount}</div>
            <div style={styles.statLabel}>Relevant to Insurance</div>
          </div>
          {upcomingEventsCount > 0 && (
            <div className="stat-card" style={{ ...styles.statCard, borderLeft: `4px solid ${colors.orange}` }}>
              <div className="stat-number" style={{ ...styles.statNumber, color: colors.orange }}>{upcomingEventsCount}</div>
              <div style={styles.statLabel}>With Upcoming Events</div>
            </div>
          )}
        </div>
        
        <div className="filter-bar" style={styles.filterBar}>
          <div className="search-container" style={styles.searchContainer}>
            <svg style={styles.searchIcon} width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search bills..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
              style={styles.searchInput}
            />
          </div>
          
          <div className="filter-buttons">
            <button
              className="filter-btn"
              style={filter === 'all' ? styles.filterBtnActive : styles.filterBtn}
              onClick={() => setFilter('all')}
            >
              All Bills ({bills.length})
            </button>
            <button
              className="filter-btn"
              style={filter === 'relevant' ? styles.filterBtnActive : styles.filterBtn}
              onClick={() => setFilter('relevant')}
            >
              Relevant ({relevantCount})
            </button>
            <button
              className="filter-btn"
              style={filter === 'following' ? styles.filterBtnActive : styles.filterBtn}
              onClick={() => setFilter('following')}
            >
              Following ({followingCount})
            </button>
          </div>
          
          <div className="sort-container" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <button
              className="filter-btn"
              onClick={() => setShowCalendarModal(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.35rem',
                padding: '0.5rem 0.75rem',
                backgroundColor: calendarEvents.length > 0 ? colors.orange + '15' : colors.white,
                border: `1px solid ${calendarEvents.length > 0 ? colors.orange : colors.border}`,
                borderRadius: '6px',
                color: calendarEvents.length > 0 ? colors.orange : colors.grayMid,
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: '500',
              }}
            >
              📅 Calendar {calendarEvents.length > 0 && `(${calendarEvents.filter(e => { const d = new Date(e.event_date); const today = new Date(); today.setHours(0,0,0,0); return d >= today; }).length})`}
            </button>
            
            <span style={styles.filterLabel}>Sort:</span>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="sort-select"
              style={styles.sortSelect}
            >
              <option value="upcoming">Next Event</option>
              <option value="relevance">Relevance</option>
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
            </select>
          </div>
        </div>
        
        {sortedBills.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyStateIcon}>📋</div>
            <div style={styles.emptyStateTitle}>No Bills Found</div>
            <div style={styles.emptyStateText}>
              {searchQuery 
                ? 'No bills match your search. Try different terms.'
                : filter !== 'all' 
                  ? 'Try changing your filter to see more bills.'
                  : 'Check back after the monitor runs to see analyzed bills.'}
            </div>
          </div>
        ) : (
          paginatedBills.map((bill, idx) => (
            <BillCard
              key={bill.bill_id || idx}
              bill={bill}
              user={user}
              followedBills={followedBills}
              onToggleFollow={handleToggleFollow}
              initialExpanded={bill.bill_id === highlightedBillId}
              onAddToCalendar={addToCalendar}
              isEventInCalendar={isEventInCalendar}
              onShowToast={showToast}
            />
          ))
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={styles.pagination}>
            <button
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              style={{
                ...styles.paginationBtn,
                ...(currentPage === 1 ? styles.paginationBtnDisabled : {})
              }}
            >
              ← Previous
            </button>

            <div style={styles.paginationInfo}>
              <span style={styles.paginationText}>
                Page {currentPage} of {totalPages}
              </span>
              <span style={styles.paginationSubtext}>
                ({startIndex + 1}-{Math.min(startIndex + BILLS_PER_PAGE, sortedBills.length)} of {sortedBills.length} bills)
              </span>
            </div>

            <button
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              style={{
                ...styles.paginationBtn,
                ...(currentPage === totalPages ? styles.paginationBtnDisabled : {})
              }}
            >
              Next →
            </button>
          </div>
        )}
      </main>
      
      <footer style={styles.footer}>
        <p>
          © {new Date().getFullYear()} Independent Insurance Agents of South Dakota
          {' · '}
          <a href="https://iiasd.org" style={styles.footerLink} target="_blank" rel="noopener noreferrer">
            iiasd.org
          </a>
        </p>
      </footer>
      
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @media (max-width: 640px) {
          .action-buttons {
            flex-direction: column !important;
            align-items: stretch !important;
          }
          .action-buttons a,
          .action-buttons button {
            width: 100% !important;
            justify-content: center !important;
            display: flex !important;
          }
          .bill-details {
            padding-left: 1rem !important;
            padding-right: 1rem !important;
          }
        }
      `}</style>

      <NotificationPreferencesModal
        isOpen={showPrefsModal}
        onClose={() => setShowPrefsModal(false)}
        preferences={notificationPrefs}
        onSave={saveNotificationPrefs}
        loading={savingPrefs}
      />

      <CalendarModal
        isOpen={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
        events={calendarEvents}
        onRemoveEvent={removeFromCalendar}
        bills={bills}
      />

      {/* Toast notification */}
      {toast && (
        <div style={styles.toast}>
          <span>{toast.message}</span>
          {toast.action && (
            <button
              onClick={() => {
                toast.action.onClick();
                setToast(null);
              }}
              style={styles.toastAction}
            >
              {toast.action.label}
            </button>
          )}
          <button
            onClick={() => setToast(null)}
            style={styles.toastClose}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}

// Public shared bill view (no auth required)
function SharedBillView({ billId }) {
  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBill = async () => {
      try {
        const response = await fetch('/bills.json?t=' + Date.now());
        const data = await response.json();
        const found = (data.bills || []).find(b => b.bill_id === billId);
        setBill(found || null);
      } catch (error) {
        console.error('Error fetching bill:', error);
      }
      setLoading(false);
    };
    fetchBill();
  }, [billId]);

  if (loading) {
    return (
      <div style={styles.loginContainer}>
        <div style={styles.loading}>
          <div style={styles.loadingSpinner}></div>
          <p style={{ color: colors.white }}>Loading...</p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!bill) {
    return (
      <div style={styles.loginContainer}>
        <div style={styles.loginBox}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>🔍</div>
            <h2 style={{ color: colors.navyDark, marginBottom: '0.5rem' }}>Bill Not Found</h2>
            <p style={{ color: colors.grayMid }}>This bill may have been removed or the link may be invalid.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logoContainer}>
            <span style={styles.logo}>
              IIASD<span style={styles.logoAccent}> Legislative Monitor</span>
            </span>
          </div>
        </div>
      </header>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '1rem' }}>
        <div style={{
          backgroundColor: colors.white,
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '1rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.75rem',
          border: `1px solid ${colors.border}`,
          textAlign: 'center',
        }}>
          <p style={{ color: colors.grayMid, fontSize: '0.9rem', margin: 0 }}>
            Shared from the IIASD Legislative Monitor
          </p>
          <a
            href={window.location.origin + window.location.pathname}
            style={{
              ...styles.linkButton,
              fontSize: '0.85rem',
              padding: '0.5rem 1rem',
              textDecoration: 'none',
            }}
          >
            Sign in for full access →
          </a>
        </div>
        <BillCard
          bill={bill}
          user={null}
          followedBills={new Set()}
          onToggleFollow={() => {}}
          initialExpanded={true}
          onAddToCalendar={null}
          isEventInCalendar={null}
          onShowToast={() => {}}
        />
      </div>
    </div>
  );
}

// Main App Component
function App() {
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) {
      setLoading(false);
      return;
    }

    // Check for existing session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        setUser(session?.user ?? null);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  const handleAuth = (user, session) => {
    setUser(user);
    setSession(session);
  };

  const handleLogout = () => {
    setUser(null);
    setSession(null);
  };

  if (loading) {
    return (
      <div style={styles.loginContainer}>
        <div style={styles.loading}>
          <div style={styles.loadingSpinner}></div>
          <p style={{ color: colors.white }}>Loading...</p>
        </div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!user) {
    const params = new URLSearchParams(window.location.search);
    const sharedBillId = params.get('bill');
    if (sharedBillId) {
      return <SharedBillView billId={parseInt(sharedBillId, 10)} />;
    }
    return <Auth onAuth={handleAuth} />;
  }

  return <Dashboard user={user} session={session} onLogout={handleLogout} />;
}

export default App;
